import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Autocomplete,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  MenuItem,
  Stack,
  Select,
  ClickAwayListener,
  FormControl,
  InputLabel,
  Divider,
  Menu,
} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import toast from "react-hot-toast";
import Paper from "@mui/material/Paper";
import Switch from "@mui/material/Switch";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import TextField from "@mui/material/TextField";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { alpha } from "@mui/material/styles";
import { visuallyHidden } from "@mui/utils";
import { format } from "date-fns";
import PropTypes from "prop-types";
import * as React from "react";
import ClipLoader from "react-spinners/ClipLoader";
import { useEffect, useState } from "react";
import {
  retrieveAllCostsApi,
  retrieveCostByIdApi,
} from "../../../components/api/CostApiService";
import {
  retrieveAllSamplesApi,
  retrieveSampleByIdApi,
} from "../../../components/api/SampleApiService";
import EditItem from "../ItemView/EditItem";
import EditCost from "../CostView/EditCost";
import EditSample from "../SampleView/EditSample";
import EditCustomerOffer from "../CustomerOfferView/EditCustomerOffer";
import {
  retrieveAllItemsApi,
  retrieveItemByIdApi,
} from "../../../components/api/ItemApiService";
import {
  retrieveFastOffersApi,
  retrieveOfferByIdApi,
} from "../../../components/api/OfferApiService";
import {
  approveOrderApi,
  cancelOrderApi,
  deleteOrdersApi,
  retrieveAllOrdersApi,
  retrieveFastFilteredOrdersApi,
  retrieveFastOrdersApi,
  retrieveFilteredOrdersApi,
  retrieveMaxOrderNumberApi,
  retrieveOrderByIdApi,
  retrieveSelectedOrdersByIdApi,
  updateOrderApi,
} from "../../../components/api/OrderApiService";
import { retrieveFastStakeholdersApi } from "../../../components/api/StakeholderApiService";
import ExportExcel from "../../../utils/excelExport";
import AddCustomerOrder from "./AddCustomerOrder";
import CreateOrder from "./CreateOrder";
import CreateShipment from "./CreateShipment";
import EditCustomerOrder from "./EditCustomerOrder";
import ExportSalesOrder from "./Dialogs/ExportSalesOrder";
import ExportProformaDetails from "./Dialogs/ExportProformaDetails";
import { retrieveUsersApi } from "../../../components/api/UserApiService";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import OfferButton from "./Dialogs/OfferButton";
import ItemButton from "./Dialogs/ItemButton";
import SampleButton from "./Dialogs/SampleButton";
import ApproveOrderButton from "./Dialogs/ApproveOrderButton";
import TradeHistoryButton from "../VendorOrderView/Dialogs/TradeHistoryButton";
import { deleteUserComponentSettingsApi, retrieveUserComponentSettingsApi, retrieveUserReportsApi, saveUserComponentSettingsApi } from "../../../components/api/UserComponentSettingsApiService";
import { DndContext, closestCenter } from '@dnd-kit/core';
import {
  SortableContext,
  useSortable,
  arrayMove,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import SortableItem from "../ShippingInstructionView/Dialogs/SortableItem";
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from "@mui/icons-material/Add";
import { retrieveAllReservationsApi } from "../../../components/api/ReservationApiService";
import { retrieveMenuItemsByTypeApi } from "../../../components/api/MenuItemApiService";
import FilterSelect from "../../../components/FilterSelect";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ExportShippingView from "../VendorOrderView/Dialogs/ExportShippingView";
import BlocksDialog from "../VendorOrderView/Dialogs/BlocksDialog";
import ApprovedEditButton from "../CustomerOfferView/Dialogs/ApproveEditButton";
import { useAuth } from "../../../auth/AuthContext";
import MyFilters from "../../../components/MyFilters";

const MAX_BULK_SELECTION = 20;


function getValueByPath(obj, path) {
  return path.split('.').reduce((acc, key) => {
    return acc ? acc[key] : undefined;
  }, obj);
}

function descendingComparator(a, b, orderBy) {
  const valueA = getValueByPath(a, orderBy);
  const valueB = getValueByPath(b, orderBy);

  if (valueA == null && valueB == null) return 0;
  if (valueA == null) return 1; 
  if (valueB == null) return -1; 

  if (orderBy === "timestamp" && typeof valueA === "string") {
    valueA = new Date(valueA);
    valueB = new Date(valueB);
  }

  if (valueB < valueA) {
    return -1;
  }
  if (valueB > valueA) {
    return 1;
  }
  return 0;

}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: "editButton",
    disablePadding: true,
    label: "",
    sx: {
      padding: "normal",
      position: "sticky",
      left: 0,
      background: "inherit",
      zIndex: 2,
      display: "flex", alignItems: "center"
    },
    render: (row, rowIndex, { setShowButtons, showButtons, setEditCustomerOrder, setOrderData, approveOrder, openDeclineDialog,
      isDeclineDialogOpen, closeDeclineDialog, declineNote, handleDecline, openAssignUserDialog, isAssignUserDialogOpen,
      closeAssignUserDialog, selectedUser, setSelectedUser, selectedRow, users, handleAssignment, setShowShipmentRequestPopup,
      loadingRecord, cancelOrder, user }) => (
      <>
        <TradeHistoryButton row={row} />
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            setShowButtons(!showButtons);
          }}
        >
          <ArrowForwardIosIcon
            style={{
              transform: showButtons
                ? "rotate(180deg)"
                : "rotate(0deg)",
            }}
          />
        </IconButton>
        {showButtons && (
          <div
            style={{
              display: "flex",
              gap: "10px",
              marginLeft: "10px",
            }}
          >
            <ApprovedEditButton
              row={row}
              isApproved={row?.approvalStatus === "Approved"}
              disabled={row?.orderStatus === "Cancelled"}
              onEdit={() => {
                setEditCustomerOrder({
                  visible: true,
                  data: row,
                  rowIndex: rowIndex,
                });
              }}
            />


            <Tooltip title="Approve Order">
              <ApproveOrderButton
                row={row}
                approveOrder={approveOrder}>
              </ApproveOrderButton>
            </Tooltip>
            <Tooltip title="Decline Order">
              <IconButton
                color="secondary"
                disabled={
                  row?.approvalStatus === "Declined" ||
                  row?.orderStatus === "Cancelled" ||
                  !row?.assignedUserId
                }
                onClick={() => {
                  if (user?.email === row?.assignedUserEmail) {
                    retrieveOrderByIdApi(row?.id)
                      .then((response) => {
                        setOrderData(response?.data);
                        openDeclineDialog(response?.data);
                      })
                      .catch((error) => {
                        window.alert("Failed to retrieve order. Please try again later.");
                      });
                  } else {
                    toast.error("This order is not assigned to you.");
                  }
    }}
  >
    <CancelIcon />
  </IconButton>
</Tooltip>
<Dialog
                            open={isDeclineDialogOpen}
                            onClose={closeDeclineDialog}
                          >
                            <DialogTitle>
                              Decline Order
                            </DialogTitle>
                            <DialogContent>
                            <Typography variant="body2">Decline Note</Typography>
                                        <TextField
                                          variant="outlined"
                                          size="small"
                                          fullWidth
                                          value={declineNote}
                                          onChange={(e) =>
                                            declineNote = e.target.value
                                          }
                                        />
                            </DialogContent>
                            <DialogActions>
                              <Button onClick={closeDeclineDialog}>
                                Cancel
                              </Button>
                              <Button
                                onClick={handleDecline}
                              >
                                Save
                              </Button>
                            </DialogActions>
                          </Dialog>

                            <Button
                              variant="outlined"
                              disabled={row?.approvalStatus === "Approved"}
                              onClick={(e) => {
                                  e.stopPropagation();
                                  retrieveOrderByIdApi(row?.id)
                                  .then((response) => {
                                    setOrderData(response?.data);
                                    openAssignUserDialog(response?.data);
                                  })
                                  .catch((error) => {
                                    window.alert("Failed to retrieve order. Please try again later.");
                                  });
                                }}
                            >
                              Assign
                            </Button>

                          <Dialog
                            open={isAssignUserDialogOpen}
                            onClose={closeAssignUserDialog}
                          >
                            <DialogTitle>
                              Assign Order to a User
                            </DialogTitle>
                            <DialogContent>
                              <Select
                                value={selectedUser}
                                onChange={(e) =>
                                  setSelectedUser(e.target.value)
                                }
                                displayEmpty
                                fullWidth
                              >
                                <MenuItem value="" disabled>
                                  {selectedRow?.assignedUserName ? selectedRow?.assignedUserName : "Select a User"}
                                </MenuItem>
                                {users.map((user) => (
                                  <MenuItem key={user} value={user}>
                                    {user.name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </DialogContent>
                            <DialogActions>
                              <Button onClick={closeAssignUserDialog}>
                                Cancel
                              </Button>
                              <Button
                                onClick={handleAssignment}
                                disabled={!selectedUser}
                              >
                                Save
                              </Button>
                            </DialogActions>
                          </Dialog>

                            <Button
                              style={{ whiteSpace: "nowrap" }}
                              variant="outlined"
                              disabled={row?.approvalStatus !== "Approved" || row?.orderStatus==="Cancelled" || row?.orderStatus==="Closed"}
                              onClick={() =>
                                  {
                                     retrieveOrderByIdApi(row?.id)
                                         .then((response) => {
                                           setShowShipmentRequestPopup({
                                             data: response?.data,
                                             visible: true,
                                           })
                                         })
                                         .catch((error) => {
                                           window.alert("Failed to retrieve order. Please try again later.");
                                         });
                                   }
                              }
                            >
                              Create Shipment Request
                            </Button>
                            {loadingRecord === row?.id ? (
                             <ClipLoader color="#000000" loadingRecord={loadingRecord} size={35} />
                              ) : (
                            <Button
                              style={{ whiteSpace: "nowrap" }}
                              variant="outlined"
                              color="warning"
                              disabled={row?.recordStatus==="PASSIVE" || row?.orderStatus==="Closed"}
                              onClick={() => {
                                if (
                                  window.confirm(
                                    `Are you sure you want to cancel SO ${
                                      row?.salesOrderNumber || ""
                                    } for item: ${
                                      row?.offerItemBuyingGrade
                                    }\nSO Quantity: ${row?.volume || "-"}  ${
                                      row?.volumeUnit || ""
                                    } `,
                                  )
                                ) {
                                   retrieveOrderByIdApi(row?.id)
                                     .then((response) => {
                                      cancelOrder(response?.data);
                                     })
                                     .catch((error) => {
                                       window.alert("Failed to retrieve order. Please try again later.");
                                     });
                                }
                              }}
                            >
                              Cancel SO
                            </Button>
                          )}
                            </div>
                            )}
      </>
      ),
  },
  {
    id: "id",
    numeric: true,
    disablePadding: true,
    label: "ID",
      sx: {
      position: "sticky",
      left: 50,
      background: "inherit",
      zIndex: 1,
    },
    render: (row) => row?.id,
  },
  {
    id: "salesOrderNumber",
    numeric: false,
    disablePadding: false,
    label: "SAP SO Number",
    render: (row) => row?.salesOrderNumber,
  },
  {
    id: "orderGroupNumber",
    numeric: false,
    disablePadding: false,
    label: "Order Group",
     render: (row) =>
      row?.orderYear && row?.orderGroupNumber
        ? `${row.orderYear}-${row.orderGroupNumber}`
        : row?.orderYear || row?.orderGroupNumber || "",
  },
  {
    id: "assignedUserName",
    numeric: false,
    disablePadding: false,
    label: "Assigned To",
    render: (row) => row?.assignedUserName,
  },
  {
    id: "orderStatus",
    numeric: false,
    disablePadding: true,
    label: "Status",
    render: (row) => row?.orderStatus,
  },
  {
    id: "company",
    numeric: false,
    disablePadding: true,
    label: "Company",
    render: (row) => row?.company,
  },
  {
    id: "offerItemId",
    numeric: true,
    disablePadding: true,
    label: "Item ID",
     render: (row, rowIndex, { setEditItem }) => (
              <ItemButton
                row={row}
                setEditItem={setEditItem}
              />
            ),
  },
  {
    id: "offerItemTobaccoCode",
    numeric: false,
    disablePadding: true,
    label: "Tobacco Code",
 sx:{
      position: "sticky",
      left: 100,
      background: "inherit",
      zIndex: 1,
    },
    render: (row) => row?.offerItemTobaccoCode,
  },
  {
    id: "offerItemBuyingGrade",
    numeric: false,
    disablePadding: true,
    label: "Buying Grade",
    sx:{
      position: "sticky",
      left: 150,
      background: "inherit",
      zIndex: 1,
    },
    render: (row) => row?.offerItemBuyingGrade,
  },
  {
    id: "offerSalesGrade",
    numeric: false,
    disablePadding: true,
    label: "Sales Grade",
    render: (row) => row?.offerSalesGrade,
  },
  {
    id: "offerItemCrop",
    numeric: true,
    disablePadding: true,
    label: "Crop",
    render: (row) => row?.offerItemCrop,
  },
  {
    id: "offerItemNicotine",
    numeric: true,
    disablePadding: true,
    label: "Nicotine",
    render: (row) => row?.offerItemNicotine,
  },
  {
    id: "offerItemSugar",
    numeric: true,
    disablePadding: true,
    label: "Sugar",
    render: (row) => row?.offerItemSugar,
  },
  {
    id: "offerItemMoisture",
    numeric: true,
    disablePadding: true,
    label: "Moisture",
    render: (row) => row?.offerItemMoisture,
  },
  {
    id: "offerItemOrigin",
    numeric: false,
    disablePadding: true,
    label: "Origin",
    render: (row) => row?.offerItemOrigin,
  },
  {
    id: "offerItemStorage",
    numeric: false,
    disablePadding: true,
    label: "Current Location",
    render: (row) => row?.offerItemStorage,
  },
  {
    id: "offerItemType",
    numeric: false,
    disablePadding: true,
    label: "Type",
    render: (row) => row?.offerItemType,
  },
  {
    id: "warehouse",
    numeric: false,
    disablePadding: true,
    label: "Warehouse",
    render: (row) => row?.warehouse,
  },
  {
    id: "stakeholderCode",
    numeric: true,
    disablePadding: true,
    label: "SAP Customer Code",
    render: (row) => row?.stakeholderCode,
  },
  {
    id: "stakeholderName",
    numeric: false,
    disablePadding: true,
    label: "Customer Name",
    render: (row) => row?.stakeholderName,
  },
  {
    id: "firstSampleId",
    numeric: true,
    disablePadding: true,
    label: "Redrawn Sample",
    render: (row, rowIndex, { setEditSample }) => (
      <SampleButton
      row={row}
      id={row?.firstSampleId}
      setEditSample={setEditSample}
    />
    ),
  },
  {
    id: "firstSampleDeliveryDate",
    numeric: true,
    disablePadding: true,
    label: "Redrawn Sample Date",
    render: (row) => (
         row?.firstSampleDeliveryDate
           ? format(
               new Date(
                 row?.firstSampleDeliveryDate,
               ),
               "dd/MM/yyyy",
             )
           : ""
       ),
  },
  {
    id: "firstSampleStatus",
    numeric: false,
    disablePadding: true,
    label: "Redrawn Sample Status",
    render: (row) => row?.firstSampleStatus,
  },
  {
    id: "packaging",
    numeric: true,
    disablePadding: true,
    label: "Packaging Type",
    render: (row) => row?.packaging,
  },
  {
    id: "packagingNicotine",
    numeric: true,
    disablePadding: true,
    label: "Packaging Nicotine",
    render: (row) => row?.packagingNicotine,
  },
  {
    id: "packagingSugar",
    numeric: true,
    disablePadding: true,
    label: "Packaging Sugar",
    render: (row) => row?.packagingSugar,
  },
  {
    id: "netWeightPerCase",
    numeric: true,
    disablePadding: true,
    label: "Net Weight Per Carton",
    render: (row) => row?.netWeightPerCase,
  },
  {
    id: "numberOfCases",
    numeric: true,
    disablePadding: true,
    label: "Number Of Cartons",
    render: (row) => row?.numberOfCases,
  },
  {
    id: "volume",
    numeric: true,
    disablePadding: true,
    label: "Quantity (KG)",
     render: (row) =>
          row?.volume
            ? `${new Intl.NumberFormat("en-US", {
                style: "decimal",
                minimumFractionDigits: 2,
              }).format(row?.volume)} ${
                row?.volumeUnit
              }`
            : "0.00",
  },
  {
    id: "remainingQuantity",
    numeric: true,
    disablePadding: true,
    label: "Remaining Quantity (KG)",
    render: (row) =>
      row?.remainingQuantity
        ? `${new Intl.NumberFormat("en-US", {
            style: "decimal",
            minimumFractionDigits: 2,
          }).format(row?.remainingQuantity)} ${
            row?.volumeUnit
          }`
        : "0.00",
  },
  {
    id: "offerFirstOfferPrice",
    numeric: true,
    disablePadding: true,
    label: "First Price",
    render: (row) =>
      row?.offerFirstOfferPrice
        ? `${new Intl.NumberFormat("en-US", {
            style: "decimal",
            minimumFractionDigits: 2,
          }).format(row?.offerFirstOfferPrice)} ${
            row?.offerFirstOfferPriceCurrency
          }`
        : "0.00",
  },
  {
    id: "offerUsdFirstOfferPrice",
    numeric: true,
    disablePadding: true,
    label: "First Price (USD)",
    render: (row) =>
      row?.offerUsdFirstOfferPrice
        ? `${new Intl.NumberFormat("en-US", {
            style: "decimal",
            minimumFractionDigits: 2,
          }).format(row?.offerUsdFirstOfferPrice)} USD`
        : "0.00",
  },
  {
    id: "finalPrice",
    numeric: true,
    disablePadding: false,
    label: "Final Price",
    render: (row) =>
      row?.finalPrice
        ? `${new Intl.NumberFormat("en-US", {
            style: "decimal",
            minimumFractionDigits: 2,
          }).format(row?.finalPrice)} ${
            row?.finalPriceCurrency
          }`
        : "0.00",
  },
  {
    id: "usdFinalPrice",
    numeric: true,
    disablePadding: false,
    label: "Final Price (USD)",
    render: (row) =>
      row?.usdFinalPrice
        ? `${new Intl.NumberFormat("en-US", {
            style: "decimal",
            minimumFractionDigits: 2,
          }).format(row?.usdFinalPrice)} USD`
        : "0.00",
  },
  {
    id: "totalAmount",
    numeric: true,
    disablePadding: true,
    label: "Total Amount",
    render: (row) =>
      row?.totalAmount
        ? `${new Intl.NumberFormat("en-US", {
            style: "decimal",
            minimumFractionDigits: 2,
          }).format(row?.totalAmount)} ${
            row?.finalPriceCurrency
          }`
        : "0.00",
  },
  {
    id: "usdTotalAmount",
    numeric: true,
    disablePadding: true,
    label: "Total Amount USD",
    render: (row) =>
      row?.totalAmount ?
      row?.usdFinalPrice
        ? `${new Intl.NumberFormat("en-US", {
            style: "decimal",
            minimumFractionDigits: 2,
          }).format(row.volume * row.usdFinalPrice)} USD`
        : "0.00":"0.00",
  },
  {
    id: "contractValueDate",
    numeric: false,
    disablePadding: true,
    label: "Contract Value Date",
    render: (row) => (
          row?.contractValueDate
            ? format(
                new Date(
                  row?.contractValueDate,
                ),
                "dd/MM/yyyy",
              )
            : ""
        ),
  },
  {
    id: "incoterm",
    numeric: true,
    disablePadding: true,
    label: "Incoterm",
    render: (row) => row?.incoterm,
  },
  {
    id: "portOfDischarge",
    numeric: true,
    disablePadding: true,
    label: "Port Of Discharge",
    render: (row) => row?.portOfDischarge,
  },
  {
    id: "portOfLoading",
    numeric: true,
    disablePadding: true,
    label: "Port Of Loading",
    render: (row) => row?.portOfLoading,
  },
  {
    id: "paymentTerm",
    numeric: false,
    disablePadding: true,
    label: "Payment Term",
    render: (row) => row?.paymentTerm,
  },
  {
    id: "operationDate",
    numeric: false,
    disablePadding: true,
    label: "Issue Date",
    render: (row) => (
      row?.operationDate
        ? format(
            new Date(
              row?.operationDate,
            ),
            "dd/MM/yyyy",
          )
        : ""
    ),
  },
  {
    id: "estimatedTimeOfDeparture",
    numeric: false,
    disablePadding: true,
    label: "ETD",
    render: (row) => (
      row?.estimatedTimeOfDeparture
        ? format(
            new Date(
              row?.estimatedTimeOfDeparture,
            ),
            "dd/MM/yyyy",
          )
        : ""
    ),
  },
  {
    id: "estimatedTimeOfArrival",
    numeric: false,
    disablePadding: true,
    label: "ETA",
    render: (row) => (
      row?.estimatedTimeOfArrival
        ? format(
            new Date(
              row?.estimatedTimeOfArrival,
            ),
            "dd/MM/yyyy",
          )
        : ""
    ),
  },
  {
    id: "description",
    numeric: false,
    disablePadding: true,
    label: "Description",
    render: (row) => row?.descriptionOfGoods?.length > 50 ? (
                                <span style={{
                                  display: 'inline-block',
                                  maxWidth: '350px', 
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  verticalAlign: 'top',
                                }}
                                title={row?.descriptionOfGoods}>
                                  {row?.descriptionOfGoods}
                                </span>
                              ) : (
                                row?.descriptionOfGoods
                              ),
  },
  {
    id: "shipmentSchedule",
    numeric: false,
    disablePadding: true,
    label: "Shipment Schedule",
  render: (row) => (
      row?.shipmentSchedule?.length > 100 ? (
        <span
          style={{
            display: "inline-block",
            maxWidth: "350px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            verticalAlign: "top",
          }}
          title={row?.shipmentSchedule}
        >
          {row?.shipmentSchedule}
        </span>
      ) : (
        row?.shipmentSchedule
      )
    ),
  },
  {
    id: "customerReference",
    numeric: false,
    disablePadding: true,
    label: "Customer Reference",
    render: (row) => row?.customerReference,
  },
  {
    id: "remark",
    numeric: false,
    disablePadding: true,
    label: "Remark",
    render: (row) => row?.remark,
  },
  {
    id: "comment",
    numeric: false,
    disablePadding: true,
    label: "Comment",
    render: (row) => row?.comment,
  },
  {
    id: "offerId",
    numeric: true,
    disablePadding: true,
    label: "Offer Id",
    render: (row, rowIndex, { setEditCustomerOffer }) => (
      <OfferButton
      row={row}
      setEditOffer={setEditCustomerOffer}
    />
    ),
  },
  {
    id: "offerNumber",
    numeric: false,
    disablePadding: true,
    label: "Offer Number",
    render: (row) => (
      (row?.offerYear ? row?.offerYear + "-" : "") + 
        row?.offerGroupNumber
    ),
  },
  {
    id: "offerDate",
    numeric: false,
    disablePadding: true,
    label: "Offer Date",
    render: (row) => (
      row?.offerDate
        ? format(
            new Date(
              row?.offerDate,
            ),
            "dd/MM/yyyy",
          )
        : ""
    ),
  },
  {
    id: "province",
    numeric: false,
    disablePadding: true,
    label: "Province",
    render: (row) => row?.province,
  },
  {
    id: "shippingTerm",
    numeric: false,
    disablePadding: false,
    label: "Shipping Term",
    render: (row) => row?.shippingTerm,
  },
  {
    id: "contractLink",
    numeric: false,
    disablePadding: false,
    label: "Contract Link",
  render: (row) => {
    const isValidUrl = (url) => {
      try {
        new URL(url);
        return true;
      } catch {
        return false;
      }
    };

    return isValidUrl(row?.contractLink) ? (
      <a
        href={row.contractLink}
        target="_blank"
        rel="noreferrer"
      >
        <Button
          disableElevation
          variant="outlined"
          size="small"
        >
          Contract Link
        </Button>
      </a>
    ) : null;
  },
  },
  {
    id: "approvalStatus",
    numeric: false,
    disablePadding: true,
    label: "SG Approval Status",
  render: (row) => (
      <span>
        {row?.approvalStatus ?? "N/A"}
        {row?.approvalStatus === "Declined" &&
          (row?.declineNote ? ` - ${row?.declineNote}` : "")}
      </span>
    ),
  },
      {
    id: "reservationId",
    numeric: false,
    disablePadding: true,
    label: "Reservation ID",
    render: (row) => row?.reservationId,
  },
  {
    id: "timestamp",
    numeric: false,
    disablePadding: true,
    label: "Creation Time",
    render: (row) => {
      const date = new Date(row?.timestamp);
      return row?.timestamp && !isNaN(date)
        ? format(date, "dd/MM/yyyy HH:mm")
        : "";
    },
  },
  {
    id: "creator",
    numeric: false,
    disablePadding: true,
    label: "Created By",
    render: (row) => row?.creator,
  },
  {
    id: "recordStatus",
    numeric: false,
    disablePadding: true,
    label: "Record Status",
    render: (row) => row?.recordStatus,
  },
];

function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    showButtons,
    visibleColumns = headCells.map(cell => cell.id),
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              "aria-label": "select all",
            }}
          />
        </TableCell>
       {headCells.filter(headCell => visibleColumns.includes(headCell.id))
           .sort((a, b) => visibleColumns.indexOf(a.id) - visibleColumns.indexOf(b.id))
           .map(headCell => (
          <TableCell
            key={headCell.id}
            align={"center"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={
              headCell.id === "editButton"
              ? {
                  position: "sticky",
                  left: 0,
                  zIndex: 3,
                }
              : headCell.id === "id"
                ? {
                    position: 'sticky',
                    left: showButtons ? 50 + 580 : 50,
                    zIndex: 3, 
                  }
                : headCell.id === "salesOrderNumber"
                ? {
                    position: 'sticky',
                    left: showButtons ? 115 + 580 : 115,
                    zIndex: 3, 
                  }
                  : headCell.id === "offer.item.tobaccoCode"
                  ? {
                      position: "sticky",
                      left: showButtons ? 274 + 580 : 274,
                      zIndex: 3,
                    }
                  : headCell.id === "offer.item.buyingGrade"
                  ? {
                      position: "sticky",
                      left: showButtons ? 417 + 580 : 417,
                      zIndex: 3,
                    }
                  : null
            }
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function CustomerOrderTable({
  visibleRows,
  dense,
  isSelected,
  handleClick,
  emptyRows,
  visibleColumns,
  onSelectAllClick,
  order,
  orderBy,
  numSelected,
  rowCount,
  onRequestSort,
  setShowButtons, 
  showButtons, 
  setEditCustomerOrder, 
  approveOrder, 
  setOrderData, 
  openDeclineDialog,
  isDeclineDialogOpen, 
  closeDeclineDialog, 
  declineNote, 
  handleDecline, 
  openAssignUserDialog, 
  isAssignUserDialogOpen,
  closeAssignUserDialog, 
  selectedUser, 
  setSelectedUser, 
  selectedRow, 
  users, 
  handleAssignment,
  setShowShipmentRequestPopup, 
  loadingRecord, 
  cancelOrder,
  setEditItem,
  setEditSample,
  setEditCustomerOffer,
  user,
}) {
  const activeHeadCells = headCells
    .filter((cell) => visibleColumns.includes(cell.id))
    .sort((a, b) => visibleColumns.indexOf(a.id) - visibleColumns.indexOf(b.id));

  return (
    <TableContainer style={{ maxHeight: 700 }}>
    <Table
                  stickyHeader
                  aria-label="sticky table"
                  sx={{
                    minWidth: 750,
                    "& .MuiTableCell-root": {
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                    },
                    "& .MuiTableCell-head": {
                      backgroundColor: "#20315d",
                      color: "white",
                      borderRight: "1px solid rgba(49, 64, 128, 1)",
                    },
                  }}
                  aria-labelledby="tableTitle"
                  size={dense ? "small" : "medium"}
                  style={{ width: "max-content" }}
                >
        <EnhancedTableHead
          numSelected={numSelected}
          order={order}
          orderBy={orderBy}
          onSelectAllClick={onSelectAllClick}
          onRequestSort={onRequestSort}
          rowCount={rowCount}
          visibleColumns={visibleColumns}
        />
        <TableBody>
          {visibleRows.map((row, rowIndex) => {
            const isItemSelected = isSelected(row.id);
            const labelId = `enhanced-table-checkbox-${rowIndex}`;
            return (
              <TableRow
                key={row.id}
                hover
                onClick={(e) => handleClick(e, row.id, row)}
                role="checkbox"
                aria-checked={isItemSelected}
                tabIndex={-1}
                selected={isItemSelected}
                style={
                  isItemSelected
                    ? { background: "#d7e7fc" }
                    : row.orderStatus === "PO Created"
                      ? { background: "#c8e6d2" }
                      : row.orderStatus === "Closed"
                        ? { background: "#FFCDD2" }
                        : rowIndex % 2
                          ? { background: "#f0f0f0" }
                          : { background: "white" }
                }
                sx={{
                  cursor: "pointer",
                }}
              >
                <TableCell padding="checkbox" id="checkbox-cell">
                  <Checkbox color="primary" checked={isItemSelected} inputProps={{ "aria-labelledby": labelId }} />
                </TableCell>
                {activeHeadCells.map((cell) => (
                  <TableCell
                   key={cell.id}
                   align="center" 
                   sx={cell.sx || {}}
                   id={`tableCell_${cell.id}`}>
                    {typeof cell.render === "function"
                      ? cell.render(row, rowIndex, {
                        setShowButtons, showButtons, setEditCustomerOrder, setOrderData, approveOrder, openDeclineDialog,
      isDeclineDialogOpen, closeDeclineDialog, declineNote, handleDecline, openAssignUserDialog, isAssignUserDialogOpen,
      closeAssignUserDialog, selectedUser, setSelectedUser, selectedRow, users, handleAssignment, setShowShipmentRequestPopup, 
      loadingRecord, cancelOrder,
                          setEditItem,
                          setEditSample,
                          setEditCustomerOffer, user
                        })
                      : row[cell.id] || ""}
                  </TableCell>
                ))}
              </TableRow>
            );
          })}
          {emptyRows > 0 && (
            <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
              <TableCell colSpan={activeHeadCells.length + 1} />
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

CustomerOrderTable.propTypes = {
  visibleRows: PropTypes.array.isRequired,
  setShowButtons: PropTypes.func.isRequired,
  showButtons: PropTypes.bool.isRequired,
  setEditCustomerOrder: PropTypes.func.isRequired,
  approveOrder: PropTypes.func.isRequired,
  setOrderData: PropTypes.func.isRequired,
  openDeclineDialog: PropTypes.func.isRequired,
  isDeclineDialogOpen: PropTypes.bool.isRequired,
  closeDeclineDialog: PropTypes.func.isRequired,
  declineNote: PropTypes.string.isRequired,
  handleDecline : PropTypes.func.isRequired,
  openAssignUserDialog: PropTypes.func.isRequired,
  isAssignUserDialogOpen: PropTypes.bool.isRequired,
  closeAssignUserDialog: PropTypes.func.isRequired,
  selectedUser: PropTypes.string.isRequired,
  setSelectedUser: PropTypes.func.isRequired,
  selectedRow: PropTypes.object.isRequired,
  users: PropTypes.array.isRequired,
  handleAssignment: PropTypes.func.isRequired,
  setShowShipmentRequestPopup: PropTypes.func.isRequired,
  loadingRecord: PropTypes.string.isRequired,
  cancelOrder: PropTypes.func.isRequired,
  setEditItem: PropTypes.array.isRequired,
  setEditSample: PropTypes.array.isRequired,
  setEditCustomerOffer: PropTypes.array.isRequired,
  user: PropTypes.object.isRequired,
};

function EnhancedTableToolbar(props) {
  const {
    numSelected,
    showFilters,
    setShowFilters,
    rows,
    setAddView,
    selected,
    setExportSoPopup,
    setExportProformaDetailsPopup,
    selectedData,
    visibleColumns,
    setVisibleColumns,
    selectedColumns,
    setSelectedColumns,
    selectColumnsDialogOpen,
    setSelectColumnsDialogOpen,
    columnsOrder,
    setColumnsOrder,
    onOpenBulkAssignDialog,
    onOpenBulkApproveDialog,
  } = props;

      const headerMapping = {
      "SAP Sales Order Number": "salesOrderNumber",
      "BP Code": "stakeholderCode",
      "BP Name": "stakeholderName",
      "Databox SO ID": "id",
      "Approval Status": "approvalStatus",
      "Order Status": "orderStatus",
      "Status Deadline": (row) => row?.statusDeadline
      ? format(new Date(row.statusDeadline), "dd/MMM/yyyy")
      : "",
      Company: "company",
      "Item ID": "offerItemId",
      "Tobacco Code": "offerItemTobaccoCode",
      "Buying Grade": "offerItemBuyingGrade",
      "Internal Grade": "offerItemInternalGrade",
      "Sales Grade": "offerSalesGrade",
      Crop: "offerItemCrop",
      Nicotine: "offerItemNicotine",
      Sugar: "offerItemSugar",
      Origin: "offerItemOrigin",
      Storage: "offerItemStorage",
      Type: "offerItemType",
      Packaging: "packaging",
      "Packaging Nicotine": "packagingNicotine",
      "Packaging Sugar": "packagingSugar",
        "Net Weight Per Carton": (row) =>
      row?.netWeightPerCase
        ? {
          v: Number(row.netWeightPerCase),
          t: 'n',
          z: '#,##0.00'
        }
        : "",
      "Number of Cartons": (row) =>
      row?.numberOfCases
        ? {
          v: Number(row.numberOfCases),
          t: 'n',
          z: '#,##0.00'
        }
        : "",
         "Final Price": (row) =>
      row?.finalPrice
        ? {
          v: Number(row.finalPrice),
          t: 'n',
          z: '#,##0.00'
        }
        : "",
      "Final Price Currency": "finalPriceCurrency",
       "USD Final Price": (row) =>
      row?.usdFinalPrice
        ? {
          v: Number(row.usdFinalPrice),
          t: 'n',
          z: '#,##0.00'
        }
        : "",
      "Total Cost": "cost?.totalCost",
     "Volume": (row) =>
      row?.volume
        ? {
          v: Number(row.volume),
          t: 'n',
          z: '#,##0.00'
        }
        : "",
    "Volume Unit": "volumeUnit",
     "Total Amount USD": (row) =>
      row?.totalAmount
        ? {
          v: Number((row?.volume ? row.volume : 0) * (row?.usdFinalPrice ? row?.usdFinalPrice : 0)),
          t: 'n',
          z: '#,##0.00'
        }
        : "",
         "Remaining Volume": (row) =>
      row?.remainingQuantity
        ? {
          v: Number(row.remainingQuantity),
          t: 'n',
          z: '#,##0.00'
        }
        : "",
   "Total Amount for Remaining Volume": (row) =>
      (row?.remainingQuantity && row.finalPrice)
        ? {
          v: Number((row.remainingQuantity ?? 0) * (row.finalPrice ?? 0)),
          t: 'n',
          z: '#,##0.00'
        }
        : "",
      Incoterm: "incoterm",
      "Payment Term": "paymentTerm",
      "Contract Value Date": (row) =>
        row?.contractValueDate ? formatDate(row.contractValueDate) : "",
      "Operation Date": (row) => row?.operationDate
          ? format(new Date(row.operationDate), "dd/MMM/yyyy")
          : "",
       "Estimated Time of Departure": (row) => row?.estimatedTimeOfDeparture
           ? format(new Date(row.estimatedTimeOfDeparture), "dd/MMM/yyyy")
           : "",
           "Estimated Time of Arrival": (row) => row?.estimatedTimeOfArrival
           ? format(new Date(row.estimatedTimeOfArrival), "dd/MMM/yyyy")
           : "",
      Remark: "remark",
      Comment: "comment",
      "Offer ID": "offerId",
    "Offer Group Number": (row) =>
      (row?.offerYear ? row.offerYear + "-" : "") +
      (row?.offerGroupNumber || ""),
    };

      const [anchorEl, setAnchorEl] = useState(null);
      const open = Boolean(anchorEl);
      const handleExportClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
      const handleClose = () => {
      setAnchorEl(null);
    };

      const [manageExportOpen, setManageExportOpen] = useState(false);
      const [exportColumns, setExportColumns] = useState(Object.keys(headerMapping));
      const [exportColumnsOrder, setExportColumnsOrder] = useState(Object.keys(headerMapping));
      const [showAddColumnInput, setShowAddColumnInput] = useState(false);
      const [newColumnName, setNewColumnName] = useState('');
      const [customColumns, setCustomColumns] = useState([]);
      
        const [reports, setReports] = useState([]);
        const [selectedReport, setSelectedReport] = useState('');
        const [showNewReportInput, setShowNewReportInput] = useState(false);
        const [newReportName, setNewReportName] = useState('');
   
 const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      setColumnsOrder((items) => {
        const oldIndex = items.indexOf(active.id);
        const newIndex = items.indexOf(over.id);
        return arrayMove(items, oldIndex, newIndex);
      });
    }
  };

  const handleExportDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      setExportColumnsOrder((items) => {
        const oldIndex = items.indexOf(active.id);
        const newIndex = items.indexOf(over.id);
        const newOrder = [...items];
        newOrder.splice(oldIndex, 1);
        newOrder.splice(newIndex, 0, active.id);
        return newOrder;
      });
    }
  };

    const handleToggle = (id) => {
      setSelectedColumns((prev) => {
        if (prev.includes(id)) {
          // Uncheck the item.
          return prev.filter(item => item !== id);
        } else {
          // Check the item.
          return [...prev, id];
        }
      });
    };
  
    const handleManageExportClick = async () => {
      try {
         const listResp = await retrieveUserReportsApi('CustomerOrderExport');
                      setReports(listResp?.data);            
                      setSelectedReport(listResp?.data[0]?.reportName || 'default');
                      const settings = await retrieveUserComponentSettingsApi('CustomerOrderExport', listResp?.data[0]?.reportName || 'default');
        const allColumns = Object.keys(headerMapping);
        setExportColumnsOrder(allColumns);
  
        if (settings?.data?.visibleColumns) {
          try {
            // Try to parse the settings data
            let parsedSettings;
  
            if (typeof settings?.data?.visibleColumns === 'string') {
              parsedSettings = JSON.parse(settings?.data?.visibleColumns);
            } else {
              // If it's already an object, use it directly
              parsedSettings = settings?.data?.visibleColumns;
            }
  
            if (Array.isArray(parsedSettings)) {
              // Set the visible columns from saved settings
              setExportColumns(parsedSettings);
  
              // Create ordered array with visible columns first, then invisible ones
              const invisibleColumns = Object.keys(headerMapping).filter(
                col => !parsedSettings.includes(col)
              );
  
              setExportColumnsOrder([...parsedSettings, ...invisibleColumns]);
            } else {
              console.warn('Saved settings are not in array format:', parsedSettings);
              setExportColumns([]);
            }
          } catch (e) {
            console.warn('Failed to parse saved settings:', e);
            setExportColumns([]);
          }
        }
        setManageExportOpen(true);
      } catch (error) {
        console.error('Error loading export settings:', error);
        toast.error('Failed to load export settings');
      }
    };
  
    function createNewExportObject(rows) {
      const newObjects = [];
      rows.forEach((row) => {
        const newObject = {};
        exportColumnsOrder
          .filter(header => exportColumns.includes(header))
          .forEach((header) => {
            const pathOrFunction = headerMapping[header];
            let value;
  
            if (typeof pathOrFunction === "function") {
              value = pathOrFunction(row);
            } else if (pathOrFunction) {
              const keys = pathOrFunction.split("?.");
              value = row;
              for (const key of keys) {
                if (value == null) break;
                value = value[key];
              }
            }
            newObject[header] = value ?? "";
          });
        newObjects.push(newObject);
      });
      return newObjects;
    }

     async function loadSettings(reportName) {
          try {
            const resp = await retrieveUserComponentSettingsApi(
              'CustomerOrderExport',
              reportName
            );
            let parsed = [];
            const raw = resp?.data?.visibleColumns;
            if (typeof raw === 'string') {
              parsed = JSON.parse(raw);
            } else if (Array.isArray(raw)) {
              parsed = raw;
            }
            setExportColumns(parsed);
            const allCols = Object.keys(headerMapping);
            const invisible = allCols.filter(c => !parsed.includes(c));
            setExportColumnsOrder([...parsed, ...invisible]);
          } catch (_) {
            const allCols = Object.keys(headerMapping);
            setExportColumns(allCols);
            setExportColumnsOrder(allCols);
          }
        }
        
        const handleDeleteReport = async () => {
          if (!selectedReport) return;
        
          if (selectedReport==="default") {
            toast.error('Default report cannot be deleted.');
            return;
          }
        
          if (!window.confirm(`Are you sure you want to delete "${selectedReport}"?`)) {
            return;
          }
        
          // find its DB id
          const report = reports.find(r => r.reportName === selectedReport);
          if (!report) return;
        
          try {
            // 1) mark it PASSIVE
            await deleteUserComponentSettingsApi('CustomerOrderExport', selectedReport);
        
            toast.success(`Report "${selectedReport}" deleted`);
        
            // 2) remove it from local list
            const updated = reports.filter(r => r.id !== report.id);
            setReports(updated);
        
            // 3) pick a new selectedReport (or reset)
            const next = updated.length ? updated[0].reportName : '';
            setSelectedReport(next);
        
            if (next) {
              // load its saved columns
              await loadSettings(next);
            } else {
              // no reports left → reset to defaults
              const all = Object.keys(headerMapping);
              setExportColumns(all);
              setExportColumnsOrder(all);
            }
          } catch (err) {
            console.error(err);
            toast.error('Failed to delete report');
          }
        };

  const [deletePopup, setDeletePopup] = useState(false);
  function formatDate(isoDateString) {
    const date = new Date(isoDateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  function createNewSapObject(rows) {
    const newObjects = [];

    rows.forEach((row, index) => {
      const newObject = {};
      newObject.itemNumber = row?.offer?.item?.tobaccoCode || "";
      newObject.itemDescription = "";
      newObject.quantity = row?.volume || "";
      const finalPrice =
        typeof row?.finalPrice === "number"
          ? row?.finalPrice.toFixed(2)
          : row?.finalPrice || "";
      newObject.unitPrice =
        (row?.finalPriceCurrency || "") + " " + finalPrice.replace(".", ",");
      newObject.discount = "";
      newObject.taxCode = "";
      newObject.totalLc =
        (row?.finalPriceCurrency || "") + " " + (row?.totalAmount || "");
      newObject.WHS = "";
      newObject.uomCode = row?.volumeUnit || "";
      newObject.cogsDepartments = "SGI_SALS";
      newObject.cogsTypeOfProduct = "LEAFTRDE";
      newObject.cogsStaff = "BSANDAL";
      newObject.blanketAgreementNumber = "";
      newObject.allowProcmntDoc = "";
      newObject.customerPoNumber = "";
      newObject.customer = row?.offer?.stakeholder?.name || "";
      newObject.customerGrade = row?.offer?.item?.salesGrade || "";
      newObject.internalGrade = row?.offer?.item?.internalGrade || "";
      newObject.vendorGrade = row?.offer?.item?.buyingGrade || "";
      newObject.countryOfOrigin = row?.offer?.item?.origin || "";
      newObject.leafType = row?.offer?.item?.type || "";
      newObject.leafForm = row?.offer?.item?.leafForm || "";
      newObject.cropYear = row?.offer?.item?.crop || "";
      newObject.kgPerCartonBaleNetWeight = row?.netWeightPerCase || "";
      newObject.numberOfCartons = row?.numberOfCases || "";
      newObject.etaDate = row?.estimatedTimeOfArrival
        ? formatDate(row.estimatedTimeOfArrival)
        : "";
      newObject.etdDate = row?.estimatedTimeOfDeparture
        ? formatDate(row.estimatedTimeOfDeparture)
        : "";
      newObject.moisture = "";
      newObject.nicotine = row?.offer?.item?.nicotine || "";
      newObject.sugar = row?.offer?.item?.sugar || "";
      newObject.color = row?.offer?.item?.color || "";
      newObject.cutWidth = "";
      newObject.fillingPower = "";
      newObject.containerTruckType = "";
      newObject.cartonPerContainerTruck = "";
      newObject.kgPerContainerTruck = "";
      newObject.temperatureTarget = "";
      newObject.numberOfContainers = "";
      newObject.packageType = row?.packaging || "";
      newObject.cartonNumberRange = "";
      newObject.containerNumber = "";
      newObject.salesQutationReferenceNumber = "";
      newObject.salesQutationReferenceDetails = "";
      newObject.salesQutationReferenceDate = "";
      newObject.netWeight = row?.volume || "";
      newObject.grossWeight = "";
      newObject.reasonForDc = "";
      newObject.description = "";
      newObject.ctcTobaccoAndPgPrice = "";
      newObject.ctcPackagingPrice = "";
      newObject.ctcProcessingPrice = "";
      newObject.salesOrderDocLineNum = "";
      newObject.salesOrderDocNum = "";
      newObject.salesOrderLineNum = "";

      newObjects.push(newObject);
    });

    return newObjects;
  }

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        ...(numSelected > 0 && {
          bgcolor: (theme) =>
            alpha(
              theme.palette.primary.main,
              theme.palette.action.activatedOpacity,
            ),
        }),
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <Dialog
        open={deletePopup}
        onClose={() => setDeletePopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete {selected.length} order(s)?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              deleteOrdersApi(selected)
                .then((response) => {
                  console.log(response?.data);
                  toast.success("Sales order(s) deleted successfully.");
                  window.location.reload();
                })
                .catch((error) => {
                  console.log(error.response?.data);
                  toast.error("Sales order(s) could not be deleted.");
                });
            }}
            autoFocus
          >
            Yes
          </Button>
          <Button onClick={() => setDeletePopup(false)}>No</Button>
        </DialogActions>
      </Dialog>

      <Stack direction="row" spacing={1} alignItems={"center"}>
        <Typography
          sx={{ fontWeight: 600, fontSize: "20px" }}
          variant="h6"
          id="tableTitle"
          component="div"
          color="#1E2685"
        >
          Sales Orders
        </Typography>

        <Typography></Typography>
        {numSelected > 0 ? (
          <Typography
            sx={{ fontWeight: 200, fontSize: "16px" }}
            color="#1E2685"
            variant="subtitle1"
            component="div"
          >
            {numSelected} selected
          </Typography>
        ) : (
          <Typography></Typography>
        )}

        {/*numSelected > 0 && (
          <Tooltip title="Delete">
            <IconButton onClick={() => setDeletePopup(true)}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        )*/}
        
        {numSelected > 0 && (
          <Button
            variant="outlined"
            onClick={onOpenBulkAssignDialog}
            disabled={numSelected > MAX_BULK_SELECTION}
          >
            Assign Selected
          </Button>
        )}
        {numSelected > 0 && (
          <Button
            variant="outlined"
            onClick={onOpenBulkApproveDialog}
            disabled={numSelected > MAX_BULK_SELECTION}
          >
            Approve Selected
          </Button>
        )}
        {numSelected > 0 && (
          <Button
            variant="outlined"
            sx={{ minWidth: "130px" }}
            style={{ whiteSpace: "nowrap", marginLeft: 20 }}
            onClick={() => {
              retrieveSelectedOrdersByIdApi(selected, "CUSTOMER")
                .then((response) => {
                  setTimeout(() => {
                    setExportSoPopup({
                      data: response?.data,
                      visible: true,
                    });
                  }, 1000);
                  toast.success("Sales orders retrieved successfully.");
                })
                .catch((error) => {
                  console.log(error.response?.data);
                  toast.error("Sales orders could not be retrieved.");
                });
            }}
          >
            Create SO Excel
          </Button>
        )}
          {numSelected > 0 && (
          <Button
            variant="outlined"
            sx={{ minWidth: "130px" }}
            style={{ whiteSpace: "nowrap", marginLeft: 20 }}
            onClick={() => {
              console.log(selected);
              retrieveSelectedOrdersByIdApi(selected, "CUSTOMER")
                .then((response) => {
                  setTimeout(() => {
                    setExportProformaDetailsPopup({
                      data: response?.data,
                      visible: true,
                    });
                  }, 1000);
                  toast.success("Sales orders retrieved successfully.");
                })
                .catch((error) => {
                  toast.error("Sales orders could not be retrieved.");
                });
            }}
          >
            Create Proforma Invoice
          </Button>
        )}
      </Stack>
      <Stack direction={"row"} spacing={1} sx={{ mr: 2 }}>
               <Button
                  disableElevation
                  variant="outlined"
                  size="small"
                  onClick={() => setSelectColumnsDialogOpen(true)}
                >
                  Select Columns
                </Button>
        
                <Dialog open={selectColumnsDialogOpen} onClose={() => setSelectColumnsDialogOpen(false)}>
                  <DialogTitle>Select Columns</DialogTitle>
                  <DialogContent>
                    {/* Buttons to select/deselect all */}
                    <Stack direction="row" spacing={2} mb={2}>
                      <Button variant="outlined" onClick={() => setSelectedColumns([...columnsOrder])}>
                        Select All
                      </Button>
                      <Button variant="outlined" onClick={() => setSelectedColumns([])}>
                        Select None
                      </Button>
                      <Button
                        variant="outlined"
                        onClick={() => {
                          const defaultOrder = headCells.map((cell) => cell.id);
                          setColumnsOrder(defaultOrder);
                          setSelectedColumns(defaultOrder);
                        }}
                      >
                        Reset
                      </Button>
                    </Stack>
                    <DndContext
                      collisionDetection={closestCenter}
                      onDragEnd={handleDragEnd}
                    >
                      <SortableContext items={columnsOrder} strategy={verticalListSortingStrategy}>
                        {columnsOrder.map((columnId) => {
                          // Find the headCell data (label etc.) for this column id.
                          const column = headCells.find(cell => cell.id === columnId);
                          return (
                            <SortableItem
                              key={columnId}
                              id={columnId}
                              label={column.label || column.id}
                              checked={selectedColumns.includes(columnId)}
                              onToggle={() => handleToggle(columnId)}
                            />
                          );
                        })}
                      </SortableContext>
                    </DndContext>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={() => setSelectColumnsDialogOpen(false)}>Cancel</Button>
                    <Button
                      variant="contained"
                      onClick={() => {
                        // Get the ordered list of selected columns according to the current columnsOrder:
                        const orderedSelectedColumns = columnsOrder.filter(id => selectedColumns.includes(id));
                        const visibleColumnsJson = JSON.stringify(orderedSelectedColumns);
                        saveUserComponentSettingsApi("CustomerOrderView", "default", visibleColumnsJson)
                          .then((response) => {
                            toast.success("Column settings saved successfully!");
                            // Update the state that controls which columns are rendered in the table.
                            setVisibleColumns(orderedSelectedColumns);
                            setSelectColumnsDialogOpen(false);
                          })
                          .catch((error) => {
                            toast.error("Failed to save column settings.");
                            console.error("Save settings error:", error);
                          });
                      }}
                    >
                      Save Column Settings
                    </Button>
                  </DialogActions>
                </Dialog>
        
                <Button
                  disableElevation
                  variant="outlined"
                  size="small"
                  onClick={handleManageExportClick}
                >
                  Manage Export
                </Button>
        
                <Dialog
                  open={manageExportOpen}
                  onClose={() => setManageExportOpen(false)}
                  maxWidth="sm"
                  fullWidth
                  PaperProps={{
                    sx: {
                      width: '600px'  
                    }
                  }}
                >
                  <DialogTitle>Manage Export Settings</DialogTitle>
                  <DialogContent>
                               <FormControl fullWidth size="small" sx={{ mb: 2, display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
                                <Select
                                  value={selectedReport}
                                  onChange={async (e) => {
                                    const name = e.target.value;
                                    setSelectedReport(name);
                                    await loadSettings(name);
                                  }}
                                  sx={{ flexGrow: 1 }}
                                >
                                  {reports?.map(r => (
                                   <MenuItem key={r.id} value={r.reportName}>
                                      {r.reportName}
                                    </MenuItem>
                                  ))}
                                </Select>
                              
                                <IconButton
                                  size="small"
                                  onClick={() => setShowNewReportInput(true)}
                                  title="New report"
                                >
                                  <AddIcon />
                                </IconButton>
                                <IconButton
                                  size="small"
                                  onClick={handleDeleteReport}
                                  disabled={!selectedReport}
                                  title="Delete report"
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </FormControl>
                              {showNewReportInput && (
                                <Box sx={{ mb: 2, display: 'flex', gap: 1 }}>
                                  <TextField
                                    size="small"
                                    value={newReportName}
                                    onChange={e => setNewReportName(e.target.value)}
                                    placeholder="New report name"
                                    fullWidth
                                  />
                                  <Button
                                    variant="contained"
                                    onClick={async () => {
                                      const name = newReportName.trim();
                                      if (!name) return;
                                      const defaultCols = Object.keys(headerMapping);
                                      await saveUserComponentSettingsApi('CustomerOrderExport', name, JSON.stringify(defaultCols));
                                      const updated = await retrieveUserReportsApi('CustomerOrderExport');
                                      setReports(updated?.data);
                                      setSelectedReport(name);
                                      await loadSettings(name);
                                      setNewReportName('');
                                      setShowNewReportInput(false);
                                    }}
                                  >
                                    Create
                                  </Button>
                                  <IconButton onClick={() => setShowNewReportInput(false)}>
                                    <CloseIcon />
                                  </IconButton>
                                </Box>
                              )}
                    <Stack direction="row" spacing={2} mb={2}>
                      <Button
                        variant="outlined"
                        onClick={() => setExportColumns(Object.keys(headerMapping))}
                      >
                        Select All
                      </Button>
                      <Button
                        variant="outlined"
                        onClick={() => setExportColumns([])}
                      >
                        Select None
                      </Button>
                      <Button
                        variant="outlined"
                        onClick={() => {
                          setExportColumns(Object.keys(headerMapping));
                          setExportColumnsOrder(Object.keys(headerMapping));
                        }}
                      >
                        Reset
                      </Button>
                      <Button
                        variant="outlined"
                        onClick={() => setShowAddColumnInput(true)}
                      >
                        Add Column
                      </Button>
                    </Stack>
                    {showAddColumnInput && (
                      <Box sx={{ mb: 2, display: 'flex', gap: 1 }}>
                        <TextField
                          size="small"
                          value={newColumnName}
                          onChange={(e) => setNewColumnName(e.target.value)}
                          placeholder="Enter column name"
                          fullWidth
                        />
                        <Button
                          variant="contained"
                          onClick={() => {
                            if (newColumnName.trim()) {
                              const newColumn = newColumnName.trim().replace(/\s+/g, ' ');
                              setCustomColumns([...customColumns, { id: newColumn, label: newColumnName }]);
                              setExportColumns([...exportColumns, newColumn]);
                              setExportColumnsOrder([...exportColumnsOrder, newColumn]);
                              setNewColumnName('');
                              setShowAddColumnInput(false);
                            }
                          }}
                        >
                          Add
                        </Button>
                        <IconButton onClick={() => setShowAddColumnInput(false)}>
                          <CloseIcon />
                        </IconButton>
                      </Box>
                    )}
                    <DndContext
                      collisionDetection={closestCenter}
                      onDragEnd={handleExportDragEnd}
                    >
                      <SortableContext
                        items={exportColumnsOrder}
                        strategy={verticalListSortingStrategy}
                      >
                        {exportColumnsOrder.map((columnId) => (
                          <Box
                            key={columnId}
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1,
                              width: '100%',
                              // Minimal styling just for layout
                              '& > div:first-of-type': {
                                flex: 1
                              }
                            }}
                          >
                            <SortableItem
                              key={columnId}
                              id={columnId}
                              label={columnId}
                              checked={exportColumns.includes(columnId)}
                              onToggle={() => {
                                if (exportColumns.includes(columnId)) {
                                  setExportColumns(exportColumns.filter(col => col !== columnId));
                                } else {
                                  setExportColumns([...exportColumns, columnId]);
                                }
                              }}
                            />
                            {customColumns.find(c => c.id === columnId) && (
                              <IconButton
                                size="small"
                                onClick={() => {
                                  setCustomColumns(customColumns.filter(c => c.id !== columnId));
                                  setExportColumns(exportColumns.filter(col => col !== columnId));
                                  setExportColumnsOrder(exportColumnsOrder.filter(col => col !== columnId));
                                }}
                                sx={{ ml: 1 }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            )}
                          </Box>
                        ))}
                      </SortableContext>
                    </DndContext>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={() => setManageExportOpen(false)}>Cancel</Button>
                    <Button
                      onClick={() => {
                        // Get visible columns in their current order
                        const orderedVisibleColumns = exportColumnsOrder.filter(id => exportColumns.includes(id));
        
                        // Stringify the array before saving
                        const settingsString = JSON.stringify(orderedVisibleColumns);
        
                        saveUserComponentSettingsApi('CustomerOrderExport', selectedReport, settingsString)
                          .then(() => {
                            toast.success('Export settings saved successfully');
                            setManageExportOpen(false);
                          })
                          .catch(error => {
                            console.error('Error saving export settings:', error);
                            toast.error('Failed to save export settings');
                          });
                      }}
                      variant="contained"
                    >
                      Save Export Settings
                    </Button>
                     <Button
                                  variant="contained"
                                  color="success"
                                  onClick={handleExportClick}
                                  endIcon={<KeyboardArrowDownIcon />}
                                >
                                  Export Options
                                </Button>
                                <Menu
                                  anchorEl={anchorEl}
                                  open={open}
                                  onClose={handleClose}
                                >
                                  <MenuItem onClick={() => {
                                    handleClose();
                                  }}>
                                   <ExportExcel
                              excelData={createNewExportObject(selectedData)}
                              fileName={"SalesOrder-"+selectedReport}
                              buttonLabel="Export Table"
                              buttonProps={{
                               variant:"contained",
                               color: "success",
                               size: "medium",
                             }}
                            />
                                  </MenuItem>
                                  <MenuItem onClick={() => {
                                    handleClose();
                                  }}>
                                      <ExportShippingView
                                  orderType="CUSTOMER"
                                  buttonLabel="Export Shipping View"
                                  buttonProps={{ variant: "contained", color: "secondary", size: "medium" }}
                                />
                                  </MenuItem>
                                </Menu>
                               <ExportExcel
                              excelData={createNewExportObject(selectedData)}
                              fileName={"SalesOrder-"+selectedReport}
                              buttonLabel="Export Table"
                              buttonProps={{
                               variant:"contained",
                               color: "success",
                               size: "medium",
                             }}
                            />
                  </DialogActions>
                </Dialog>

        <ExportExcel
          excelData={createNewSapObject(selectedData)}
          fileName={"ExcelExportSAP"}
          buttonLabel="SAP Export"
        />
       {/* <Button
          disableElevation
          variant="outlined"
          size="small"
          onClick={() => setAddView(true)}
        >
          Add
        </Button>*/}
        <Button
          variant="outlined"
          onClick={() => setShowFilters(!showFilters)}
          sx={{ minWidth: "130px" }}
          size="small"
        >
          {showFilters ? "Hide Filters" : "Show Filters"}
        </Button>
      </Stack>
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onOpenBulkAssignDialog: PropTypes.func.isRequired,
  onOpenBulkApproveDialog: PropTypes.func.isRequired,
};

export default function CustomerOrder() {
  const componentName = "CustomerOrderView";
  const { user, userLoading } = useAuth();
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("calories");
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [addView, setAddView] = useState(false);
  const [addViewStates, setAddViewStates] = useState(null);
  const [rows, setRows] = useState([]);
  const [items, setItems] = useState([]);
  const [samples, setSamples] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [users, setUsers] = useState([]);
  const [isAssignUserDialogOpen, setIsAssignUserDialogOpen] = useState(false);
  const [isDeclineDialogOpen, setIsDeclineDialogOpen] = useState(false);
  const [isBulkAssignDialogOpen, setIsBulkAssignDialogOpen] = useState(false);
  const [isBulkApproveDialogOpen, setIsBulkApproveDialogOpen] = useState(false);
  const [bulkSelectedUser, setBulkSelectedUser] = useState("");
  const [selectedUser, setSelectedUser] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [costs, setCosts] = useState([]);
  const [showFilters, setShowFilters] = useState();
  const [offers, setOffers] = useState([]);
  const [orders, setOrders] = useState([]);
  const [reservations, setReservations] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [orderData, setOrderData] = useState([]);
  const [maxOrderGroupNumber, setMaxOrderGroupNumber] = useState();
  const [showButtons, setShowButtons] = useState(false);
  let declineNote = null;
  const totalVolume = rows.reduce((sum, row) => sum + (row.volume || 0), 0);
  const usdTotalAmount = rows.reduce((sum, row) => sum + (row?.volume ? row?.usdFinalPrice ? (row.volume*row.usdFinalPrice) : 0 : 0), 0);
  const [visibleColumns, setVisibleColumns] = useState(headCells.map(cell => cell.id));
  const [selectColumnsDialogOpen, setSelectColumnsDialogOpen] = useState(false);
  const [columnsOrder, setColumnsOrder] = useState(headCells.map(cell => cell.id));
  const [selectedColumns, setSelectedColumns] = useState(headCells.map(cell => cell.id));

      useEffect(() => {
          retrieveUserComponentSettingsApi(componentName, 'default')
            .then((response) => {
              const allColumnIds = headCells.map(cell => cell.id);
              if (response.data && response.data.visibleColumns) {
                const savedColumns = JSON.parse(response.data.visibleColumns); 
                const combinedOrder = [
                  ...savedColumns,
                  ...allColumnIds.filter(id => !savedColumns.includes(id))
                ];
                setVisibleColumns(savedColumns);      
                setColumnsOrder(combinedOrder);             
                setSelectedColumns(savedColumns);           
              } else {
                setVisibleColumns(allColumnIds);
                setColumnsOrder(allColumnIds);
                setSelectedColumns(allColumnIds);
              }
            })
            .catch((error) => {
              console.error("Error loading column settings:", error);
            });
        }, [componentName]);

  const [editItem, setEditItem] = useState({
    visible: false,
    data: null,
    index: null,
  });
  const [editCost, setEditCost] = useState({
    visible: false,
    data: null,
    index: null,
  });
  const [editSample, setEditSample] = useState({
    visible: false,
    data: null,
    index: null,
  });
  const [editCustomerOffer, setEditCustomerOffer] = useState({
    visible: false,
    data: null,
    index: null,
  });

   function mapOrder(order) {
      return {
        ...order, 
            assignedUserId: order?.assignedUser?.id,
            assignedUserName: order?.assignedUser?.name,
            assignedUserEmail: order?.assignedUser?.email,
            stakeholderId: order?.offer?.stakeholder?.id,
            stakeholderCode: order?.offer?.stakeholder?.code,
            stakeholderName: order?.offer?.stakeholder?.name,
            firstSampleId: order?.firstSample?.id,
            firstSampleDeliveryDate: order?.firstSample?.deliveryDate,
            firstSampleStatus: order?.firstSampleStatus,
            offerFirstOfferPrice: order?.offer?.firstOfferPrice,
            offerFirstOfferPriceCurrency : order?.offer?.firstOfferPriceCurrency,
            offerUsdFirstOfferPrice: order?.offer?.usdFirstOfferPrice,
            offerId: order?.offer?.id,
            offerDate: order?.offer?.offerDate,
            offerYear: order?.offer?.offerYear,
            offerGroupNumber: order?.offer?.offerGroupNumber,
            offerItemId: order?.offer?.item?.id,
            offerItemTobaccoCode: order?.offer?.item?.tobaccoCode,
            offerItemBuyingGrade: order?.offer?.item?.buyingGrade,
            offerSalesGrade: order?.offer?.salesGrade,
            offerItemOrigin: order?.offer?.item?.origin,
            offerItemType: order?.offer?.item?.type,
            offerItemCrop: order?.offer?.item?.crop,
            offerItemStorage: order?.offer?.item?.storage,
            offerItemNicotine: order?.offer?.item?.nicotine,
            offerItemSugar: order?.offer?.item?.sugar,
            offerItemMoisture: order?.offer?.item?.moisture,
      };
    }

  const openDeclineDialog = (row) => {
    setSelectedRow(row);
    setIsDeclineDialogOpen(true);
  };
  const closeDeclineDialog = () => {
    setIsDeclineDialogOpen(false);
    setSelectedRow(null);
  };

  const openAssignUserDialog = (row) => {
    setSelectedRow(row);
    setIsAssignUserDialogOpen(true);
  };
  const closeAssignUserDialog = () => {
    setIsAssignUserDialogOpen(false);
    setSelectedRow(null);
    setSelectedUser("");
  };

  const handleAssignment = () => {
    if (selectedRow && selectedUser) {
      const assignmentDate = new Date();
      retrieveOrderByIdApi(selectedRow.id)
      .then((detailsResponse) => {
        const baseRow = detailsResponse?.data || selectedRow;
        const updatedRow = {
          ...baseRow,
          assignedUser: selectedUser,
          assignedUserId: selectedUser?.id,
          assignedUserName: selectedUser?.name,
          assignedUserEmail: selectedUser?.email,
          assignor: user?.email,
          assignmentDate,
          operation: "ASSIGNMENT"
        };
        return updateOrderApi(updatedRow.id, updatedRow).then(() => updatedRow);
      })
      .then((updatedRow) => {
        toast.success(
          `Purchase order assigned to ${updatedRow.assignedUser.name} successfully.`,
          { autoClose: 4000 } 
        );
        if (rows && setRows) {
          const idx = rows.findIndex(row => row.id === updatedRow.id);
        
          if (idx !== -1) {
            const newRows = [...rows];
            newRows[idx] = { ...newRows[idx],  
              assignedUser: selectedUser, 
              assignedUserId: selectedUser?.id,
              assignedUserName: selectedUser?.name, 
              assignedUserEmail: selectedUser?.email, 
              assignor: user?.email, 
              assignmentDate, 
              operation: "ASSIGNMENT"};
            setRows(newRows); 
          }
        }
        setSelectedData((prevSelectedData) =>
          prevSelectedData.map((row) =>
            row.id === updatedRow.id
              ? {
                  ...row,
                  assignedUser: selectedUser,
                  assignedUserId: selectedUser?.id,
                  assignedUserName: selectedUser?.name,
                  assignedUserEmail: selectedUser?.email,
                  assignor: user?.email,
                  assignmentDate,
                  operation: "ASSIGNMENT",
                }
              : row,
          ),
        );
        closeAssignUserDialog();
      })
      .catch((error) => {
        toast.error("Something went wrong.");
        console.log(error.response.data);
      });
    }
  };

  const handleDecline = () => {
    if (selectedRow) {
      const note = declineNote || ""; 
      const updatedRow = { ...selectedRow, 
        declineNote: note, 
        approvalStatus: "Declined", 
        operation:"DECLINE" };
      
      updateOrderApi(updatedRow.id, updatedRow)
      .then((response) => {
          toast.success(
              `Purchase order declined successfully.`,
              { autoClose: 4000 } 
          );
          if (rows && setRows) {
            const idx = rows.findIndex(row => row.id === updatedRow.id);
          
            if (idx !== -1) {
              const newRows = [...rows];
              newRows[idx] = { ...newRows[idx],  
                declineNote: note, 
                approvalStatus: "Declined", 
                operation:"DECLINE" };
              setRows(newRows); 
            }
          }
      })
      .catch((error) => {
          toast.error("Something went wrong.");
          console.log(error.response.data);
      });
      
      closeDeclineDialog();
  }
  };
  
  const [exportSoPopup, setExportSoPopup] = useState({
    visible: false,
    data: null,
  });
  const [exportProformaDetailsPopup, setExportProformaDetailsPopup] = useState({
    visible: false,
    data: null,
  });
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const [componentsState, setComponentsState] = useState({
    origin: {
      dropdownOpen: false,
      inputValue: "",
    },
    item: {
      dropdownOpen: false,
      inputValue: "",
    },
    customer: {
      dropdownOpen: false,
      inputValue: "",
    },
    type: {
      dropdownOpen: false,
      inputValue: "",
    },
    leafForm: {
      dropdownOpen: false,
      inputValue: "",
    },
    storage: {
      dropdownOpen: false,
      inputValue: "",
    },
    cost: {
      dropdownOpen: false,
      inputValue: "",
    },
    firstSample: {
      dropdownOpen: false,
      inputValue: "",
    },
    secondSample: {
      dropdownOpen: false,
      inputValue: "",
    },
    paymentTerm: {
      dropdownOpen: false,
      inputValue: "",
    },
    offer: {
      dropdownOpen: false,
      inputValue: "",
    },
      reservation: {
      dropdownOpen: false,
      inputValue: "",
    },
        order: {
      dropdownOpen: false,
      inputValue: "",
    },
  });

  const [item, setItem] = useState([]);
  const [cost, setCost] = useState([]);
  const [sample, setSample] = useState([]);
  const [offer, setOffer] = useState([]);
  const [loadingRecord, setLoadingRecord] = useState(null);
  const [blockData, setBlockData] = useState([]);
  const [blocksOpen, setBlocksOpen] = useState(false);
  
  const openBlocksDialog = (blocks) => {
    setBlockData(Array.isArray(blocks) ? blocks : []);
    setBlocksOpen(true);
  };

  const updateComponentState = (componentKey, newState) => {
    setComponentsState((prevState) => ({
      ...prevState,
      [componentKey]: {
        ...prevState[componentKey],
        ...newState,
      },
    }));
  };

  const [filterCustomerOrder, setFilterCustomerOrder] = useState({
    id: 0,
    orderType: "CUSTOMER",
    stakeHolderType: "CUSTOMER",
    itemBuyingGrade: "",
    itemIdList: [],
    stakeholderIdList: [],
    costIdList: [],
    offerIdList: [],
    companyList: [],
    approvalStatusList: [],
    orderStatusList: [],
    customerList: [],
    firstSampleId: "",
    secondSampleId: "",
    costId: "",
    firstSampleIdList: [],
    secondSampleIdList: [],
    firstSampleStatusList: [],
    secondSampleStatusList: [],
    paymentTerm: "",
    paymentTermList: [],
    incotermList: [],
    portOfLoadingList: [],
    portOfDischargeList: [],
    packagingList: [],
    volumeUnitList: [],
    firstPriceCurrencyList: [],
    finalPriceCurrencyList: [],
    remark: "",
    shipmentSchedule: "",
    comment: "",
    documentStatusList: [],
    tobaccoCode: "",
    salesGrade: "",
    buyingGrade: "",
    customerGrade: "",
    internalGrade:"",
    originList: [],
    typeList: [],
    leafFormList: [],
    colorList: [],
    storageList: [],
    reservationIdList: [],
    itemStorage: "",
    recordStatusList: ["ACTIVE"],
    orderIdList: [],
  });

  useEffect(() => {
    retrieveCustomerOrders();
    getMaxOrderNumber();
    retrieveUsers();
  }, []);

   function retrieveUsers() {
        retrieveUsersApi()
          .then((response) => {
            setUsers(response?.data);
          })
          .catch((error) => console.log(error.response?.data));
      }

  function approveOrder(orderId) {
    approveOrderApi(orderId)
      .then((response) => {
         if (rows && setRows) {
                  const idx = rows.findIndex(row => row.id === orderId);
                  
                  if (idx !== -1) {
                    const newRows = [...rows];
                    newRows[idx] = { ...newRows[idx], approvalStatus: "Approved" }; 
                    setRows(newRows);
                  }
                }
        toast.success("Order approved successfully.");
      })
      .catch((error) => {
        console.log(error.response.data);
      });
  }

  const openBulkAssignDialog = () => {
    if (!selectedData.length) {
      toast.error("Please select at least one order.");
      return;
    }
    if (selectedData.length > MAX_BULK_SELECTION) {
      toast.error(`You can select up to ${MAX_BULK_SELECTION} orders for bulk actions.`);
      return;
    }
    setBulkSelectedUser("");
    setIsBulkAssignDialogOpen(true);
  };

  const closeBulkAssignDialog = () => {
    setBulkSelectedUser("");
    setIsBulkAssignDialogOpen(false);
  };

  const openBulkApproveDialog = () => {
    if (!selectedData.length) {
      toast.error("Please select at least one order.");
      return;
    }
    if (selectedData.length > MAX_BULK_SELECTION) {
      toast.error(`You can select up to ${MAX_BULK_SELECTION} orders for bulk actions.`);
      return;
    }
    setIsBulkApproveDialogOpen(true);
  };

  const closeBulkApproveDialog = () => {
    setIsBulkApproveDialogOpen(false);
  };

  const handleBulkAssignment = async () => {
    if (selectedData.length > MAX_BULK_SELECTION) {
      toast.error(`Bulk assignment supports up to ${MAX_BULK_SELECTION} orders at once.`);
      return;
    }

    if (!bulkSelectedUser) {
      toast.error("Please select a user.");
      return;
    }

    const eligibleRows = selectedData.filter((row) => row?.approvalStatus !== "Approved");
    if (!eligibleRows.length) {
      toast.error("Selected orders are already approved and cannot be reassigned.");
      return;
    }

    const assignmentDate = new Date();
    const results = await Promise.allSettled(
      eligibleRows.map(async (row) => {
        const detailsResponse = await retrieveOrderByIdApi(row.id);
        const baseRow = detailsResponse?.data || row;
        const updatedRow = {
          ...baseRow,
          assignedUser: bulkSelectedUser,
          assignedUserId: bulkSelectedUser?.id,
          assignedUserName: bulkSelectedUser?.name,
          assignedUserEmail: bulkSelectedUser?.email,
          assignor: user?.email,
          assignmentDate,
          operation: "ASSIGNMENT",
        };
        return updateOrderApi(updatedRow.id, updatedRow);
      }),
    );

    const successCount = results.filter((result) => result.status === "fulfilled").length;
    const failedCount = results.length - successCount;

    if (successCount > 0) {
      const successIds = new Set(
        eligibleRows
          .filter((_, index) => results[index].status === "fulfilled")
          .map((row) => row.id),
      );
      setRows((prevRows) =>
        prevRows.map((row) =>
          successIds.has(row.id)
            ? {
                ...row,
                assignedUser: bulkSelectedUser,
                assignedUserId: bulkSelectedUser?.id,
                assignedUserName: bulkSelectedUser?.name,
                assignedUserEmail: bulkSelectedUser?.email,
                assignor: user?.email,
                assignmentDate,
                operation: "ASSIGNMENT",
              }
            : row,
        ),
      );
      setSelectedData((prevSelectedData) =>
        prevSelectedData.map((row) =>
          successIds.has(row.id)
            ? {
                ...row,
                assignedUser: bulkSelectedUser,
                assignedUserId: bulkSelectedUser?.id,
                assignedUserName: bulkSelectedUser?.name,
                assignedUserEmail: bulkSelectedUser?.email,
                assignor: user?.email,
                assignmentDate,
                operation: "ASSIGNMENT",
              }
            : row,
        ),
      );
    }

    if (successCount > 0) {
      toast.success(`${successCount} sales order(s) assigned successfully.`);
    }
    if (failedCount > 0) {
      toast.error(`${failedCount} sales order(s) could not be assigned.`);
    }

    closeBulkAssignDialog();
  };

  const handleBulkApprove = async () => {
    if (selectedData.length > MAX_BULK_SELECTION) {
      toast.error(`Bulk approval supports up to ${MAX_BULK_SELECTION} orders at once.`);
      return;
    }

    const notOwnedRows = selectedData.filter(
      (row) => row?.assignedUserEmail !== user?.email,
    );
    const eligibleRows = selectedData.filter(
      (row) => row?.approvalStatus !== "Approved"
        && row?.orderStatus !== "Cancelled"
        && row?.orderStatus !== "Closed"
        && row?.assignedUserEmail === user?.email,
    );

    if (notOwnedRows.length > 0) {
      toast.error(
        `${notOwnedRows.length} selected order(s) are not assigned to you and were skipped.`,
      );
    }

    if (!eligibleRows.length) {
      toast.error("No selected order is eligible for approval by you.");
      return;
    }

    const results = await Promise.allSettled(
      eligibleRows.map((row) => approveOrderApi(row.id)),
    );

    const successCount = results.filter((result) => result.status === "fulfilled").length;
    const failedCount = results.length - successCount;

    if (successCount > 0) {
      const successIds = new Set(
        eligibleRows
          .filter((_, index) => results[index].status === "fulfilled")
          .map((row) => row.id),
      );
      setRows((prevRows) =>
        prevRows.map((row) =>
          successIds.has(row.id)
            ? {
                ...row,
                approvalStatus: "Approved",
              }
            : row,
        ),
      );
    }

    if (successCount > 0) {
      toast.success(`${successCount} sales order(s) approved successfully.`);
    }
    if (failedCount > 0) {
      toast.error(`${failedCount} sales order(s) could not be approved.`);
    }

    closeBulkApproveDialog();
  };

  const cancelOrder = async (order) => {
    setLoadingRecord(order?.id);
     const updatedOrderData = {
      ...order,
      recordStatus: "PASSIVE",
      orderStatus: "Cancelled",
      operation: "Cancelling",
    };
    try {
    const response = await updateOrderApi(order?.id, updatedOrderData);
    toast.success("Order cancelled successfully.");
     if (rows && setRows) {
            const idx = rows.findIndex(row => row.id === updatedOrderData.id);
          
            if (idx !== -1) {
              const newRows = [...rows];
              newRows[idx] = { ...newRows[idx],  
                recordStatus: "PASSIVE",
                orderStatus: "Cancelled",
                operation: "Cancelling",
              };
              setRows(newRows); 
            }
          }
      } catch (error) {
        console.log(error.response.data);
         if (error?.response?.status === 409) {
           const { message, blocks } = error.response.data;
           openBlocksDialog(blocks); 
           toast.error(message);
           return;
         }
        toast.error("Something went wrong. ",error.response.data);
      }finally {
        setLoadingRecord(null);
      }
  };

function retrieveCustomerOrders(target = "rows") {
  retrieveFastOrdersApi("CUSTOMER")
    .then((response) => {
      if (target === "rows") {
        setRows(response?.data);
      } else if (target === "orders") {
        setOrders(response?.data);
      }
    })
    .catch((error) => console.log(error.response?.data));
}

  function retrieveItems() {
    retrieveAllItemsApi()
      .then((response) => {
        setItems(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveItemById(id) {
    retrieveItemByIdApi(id)
      .then((response) => {
        setItem(response?.data);
        console.log(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveSamples() {
    retrieveAllSamplesApi()
      .then((response) => {
        setSamples(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveSampleById(id) {
    retrieveSampleByIdApi(id)
      .then((response) => {
        setSample(response?.data);
        console.log(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveCustomers() {
    retrieveFastStakeholdersApi("CUSTOMER")
      .then((response) => {
        setCustomers(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveCosts() {
    retrieveAllCostsApi()
      .then((response) => {
        setCosts(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveCostById(id) {
    retrieveCostByIdApi(id)
      .then((response) => {
        setCost(response?.data);
        console.log(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveOffers() {
    retrieveFastOffersApi("CUSTOMER")
      .then((response) => {
        setOffers(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

    function retrieveReservations() {
    retrieveAllReservationsApi("CUSTOMER")
      .then((response) => {
        setReservations(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  function retrieveOfferById(id) {
    retrieveOfferByIdApi(id)
      .then((response) => {
        setOffer(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }
  function getMaxOrderNumber() {
    retrieveMaxOrderNumberApi("CUSTOMER")
      .then((response) => {
        console.log(response?.data);
        setMaxOrderGroupNumber(response?.data);
      })
      .catch((error) => console.log(error.response?.data));
  }

  const newOrderGroupNumber =
    maxOrderGroupNumber + (Math.floor(Math.random() * 5) + 1);

  const [editCustomerOrder, setEditCustomerOrder] = useState({
    visible: false,
    data: null,
    index: null,
  });
  const [showOrderPopup, setShowOrderPopup] = useState({
    visible: false,
    data: null,
  });
  const [showShipmentRequestPopup, setShowShipmentRequestPopup] = useState({
    visible: false,
    data: null,
  });

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.id);
      setSelected(newSelected);
      setSelectedData(rows);
      return;
    }else{
      setSelected([]);
      setSelectedData([]);
    }
  };
  
  const handleClick = (event, name, row) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    const selectedDataIndex = selectedData.indexOf(row);
    let newSelectedData = [];

    if (selectedDataIndex === -1) {
      newSelectedData = newSelectedData.concat(selectedData, row);
    } else if (selectedDataIndex === 0) {
      newSelectedData = newSelectedData.concat(selectedData.slice(1));
    } else if (selectedDataIndex === selectedData.length - 1) {
      newSelectedData = newSelectedData.concat(selectedData.slice(0, -1));
    } else if (selectedDataIndex > 0) {
      newSelectedData = newSelectedData.concat(
        selectedData.slice(0, selectedDataIndex),
        selectedData.slice(selectedDataIndex + 1),
      );
    }
    setSelectedData(newSelectedData);
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const visibleRows = React.useMemo(
    () =>
      stableSort(rows, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage,
      ),
    [order, orderBy, page, rowsPerPage, rows, editCustomerOrder],
  );

      if (userLoading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <div>Not authorized</div>;
  }

  return (
    <div>
      {addView ? (
        <AddCustomerOrder
          setAddViewStates={setAddViewStates}
          addViewStates={addViewStates}
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          newOrderGroupNumber={newOrderGroupNumber}
        />
      ) : editCustomerOrder.visible ? (
        <EditCustomerOrder
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          editCustomerOrder={editCustomerOrder}
          setEditCustomerOrder={setEditCustomerOrder}
          mapOrder={mapOrder}
        />
      ) : showOrderPopup.visible ? (
        <CreateOrder
          setCreateOrder={setShowOrderPopup}
          createOrder={showOrderPopup}
        />
      ) : showShipmentRequestPopup.visible ? (
        <CreateShipment
          setCreateShipmentRequest={setShowShipmentRequestPopup}
          createShipmentRequest={showShipmentRequestPopup}
        />
      ) : editItem.visible ? (
        <EditItem
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          editItem={editItem}
          setEditItem={setEditItem}
        />
      ) : editCost.visible ? (
        <EditCost
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          editCost={editCost}
          setEditCost={setEditCost}
        />
      ) : editSample.visible ? (
        <EditSample
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          editSample={editSample}
          setEditSample={setEditSample}
        />
      ) : editCustomerOffer.visible ? (
        <EditCustomerOffer
          rows={rows}
          setRows={setRows}
          setAddView={setAddView}
          editCustomerOffer={editCustomerOffer}
          setEditCustomerOffer={setEditCustomerOffer}
        />
      ) : exportSoPopup.visible ? (
        <ExportSalesOrder
          setExportSoPopup={setExportSoPopup}
          exportSoPopup={exportSoPopup}
        /> ) : exportProformaDetailsPopup.visible ? (
          <ExportProformaDetails
          setExportProformaDetailsPopup={setExportProformaDetailsPopup}
          exportProformaDetailsPopup={exportProformaDetailsPopup}
        />
      ) : (
        <>
          {showFilters && (
            <Box
              component="form"
              sx={{
                "& .MuiTextField-root": { m: 1, width: "25ch" },
              }}
              noValidate
              autoComplete="off"
            >
              <Grid
                container
                spacing={1}
                justifyContent="flex-start"
                alignItems="center"
              >
                {/*<TextField
                  id="outlined-search"
                  label="Group Number"
                  value={filterCustomerOrder?.orderGroupNumber || ""}
                  type="number"
                  onChange={(e) =>
                    setFilterCustomerOrder({
                      ...filterCustomerOrder,
                      orderGroupNumber: e.target.value,
                    })
                  }
                />*/}

                <Autocomplete
                  multiple
                  id="outlined-select-order"
                  disableClearable
                  open={componentsState.order.dropdownOpen}
                  onOpen={() =>
                    updateComponentState("order", { dropdownOpen: true })
                  }
                  inputValue={componentsState.order.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("order", {
                        inputValue: newInputValue,
                      });
                    }
                  }}
                  options={[
                    ...orders.filter((order) =>
                      filterCustomerOrder.orderIdList.includes(order.id),
                    ),
                    ...orders.filter(
                      (order) =>
                        !filterCustomerOrder.orderIdList.includes(order.id),
                    ),
                  ]}
                  getOptionLabel={(option) =>
                    `ID: ${option?.id || ""} - SAP SO Number: ${
                      option?.salesOrderNumber || ""
                    }`
                  }
                  value={orders.filter((order) =>
                    filterCustomerOrder.orderIdList.includes(order.id),
                  )}
                  onChange={(event, newValue) => {
                    setFilterCustomerOrder({
                      ...filterCustomerOrder,
                      orderIdList: newValue.map((order) => order.id),
                    });
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      style={{
                        ...props.style,
                        backgroundColor: selected ? "lightblue" : undefined,
                        fontWeight: selected ? 700 : 400,
                      }}
                    >
                      {`ID: ${option?.id || ""} - SAP SO Number: ${
                        option?.salesOrderNumber || ""
                      }`}
                    </li>
                  )}
                  renderInput={(params) => {
                    const label =
                      filterCustomerOrder?.orderIdList.length > 0
                        ? `Sales Orders Selected (${filterCustomerOrder?.orderIdList.length})`
                        : "Sales Order";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.order.inputValue}
                        onChange={(e) =>
                          updateComponentState("order", {
                            inputValue: e.target.value,
                          })
                        }
                        onMouseDown={() => retrieveCustomerOrders("orders")}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("order", { dropdownOpen: false })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />

                <TextField
                  id="outlined-search"
                  label="SAP SO Number"
                  value={filterCustomerOrder?.salesOrderNumber || ""}
                  type="number"
                onWheel={(e) => e.target.blur()}
                  onChange={(e) =>
                    setFilterCustomerOrder({
                      ...filterCustomerOrder,
                      salesOrderNumber: e.target.value,
                    })
                  }
                />

                <Autocomplete
                  multiple
                  id="outlined-select-offer"
                  disableClearable
                  open={componentsState.offer.dropdownOpen}
                  onOpen={() =>
                    updateComponentState("offer", { dropdownOpen: true })
                  }
                  inputValue={componentsState.offer.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("offer", {
                        inputValue: newInputValue,
                      });
                    }
                  }}
                  options={[
                    ...offers.filter((offer) =>
                      filterCustomerOrder.offerIdList.includes(offer.id),
                    ),
                    ...offers.filter(
                      (offer) =>
                        !filterCustomerOrder.offerIdList.includes(offer.id),
                    ),
                  ]}
                  getOptionLabel={(option) =>
                    `ID: ${option?.id || ""} Offer Number: ${
                      option?.offerYear || ""
                    } - ${option?.offerGroupNumber || ""}`
                  }
                  value={offers.filter((offer) =>
                    filterCustomerOrder.offerIdList.includes(offer.id),
                  )}
                  onChange={(event, newValue) => {
                    setFilterCustomerOrder({
                      ...filterCustomerOrder,
                      offerIdList: newValue.map((offer) => offer.id),
                    });
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      style={{
                        ...props.style,
                        backgroundColor: selected ? "lightblue" : undefined,
                        fontWeight: selected ? 700 : 400,
                      }}
                    >
                      {`ID: ${option?.id || ""} Offer Number: ${
                        option?.offerYear || ""
                      } - ${option?.offerGroupNumber || ""}`}
                    </li>
                  )}
                  renderInput={(params) => {
                    const label =
                      filterCustomerOrder?.offerIdList.length > 0
                        ? `Offers Selected (${filterCustomerOrder?.offerIdList.length})`
                        : "Offer";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.offer.inputValue}
                        onChange={(e) =>
                          updateComponentState("offer", {
                            inputValue: e.target.value,
                          })
                        }
                        onMouseDown={retrieveOffers}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("offer", { dropdownOpen: false })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />

<FilterSelect
  label="SG Approval Status"
  menuType="orderApprovalStatus"
  value={filterCustomerOrder.approvalStatusList}
  onChange={(e) => setFilterCustomerOrder({
    ...filterCustomerOrder,
    approvalStatusList: e.target.value
  })}
  multiple
/>

                {/* <TextField
                  label="Status"
                  type="search"
                  id="outlined-select-status"
                  select
                  SelectProps={{
                    multiple: true,
                    value: filterCustomerOrder.orderStatusList || [],
                    onChange: (e) => {
                      setFilterCustomerOrder({
                        ...filterCustomerOrder,
                        orderStatusList: e.target.value,
                      });
                    },
                  }}
                >
                  {status.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  id="date"
                  type="date"
                  label="Status Deadline"
                  value={filterCustomerOrder?.statusDeadline || ""}
                  inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) =>
                    setFilterCustomerOrder({
                      ...filterCustomerOrder,
                      statusDeadline: e.target.value,
                    })
                  }
                />
                */}
             {/*   <TextField
                  label="Company"
                  type="search"
                  id="outlined-select-company"
                  select
                  SelectProps={{
                    multiple: true,
                    value: filterCustomerOrder.companyList || [],
                    onChange: (e) => {
                      setFilterCustomerOrder({
                        ...filterCustomerOrder,
                        companyList: e.target.value,
                      });
                    },
                  }}
                >
                  {companies.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>*/}

                <FilterSelect
  label="Company"
  menuType="companies"
  value={filterCustomerOrder.companyList}
  onChange={(e) => setFilterCustomerOrder({
    ...filterCustomerOrder,
    companyList: e.target.value
  })}
  multiple
/>

                <Autocomplete
                  multiple
                  id="outlined-select-item"
                  disableClearable
                  open={componentsState.item.dropdownOpen}
                  onOpen={() =>
                    updateComponentState("item", { dropdownOpen: true })
                  }
                  inputValue={componentsState.item.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("item", {
                        inputValue: newInputValue,
                      });
                    }
                  }}
                  options={[
                    ...items.filter((item) =>
                      filterCustomerOrder.itemIdList.includes(item.id),
                    ),
                    ...items.filter(
                      (item) =>
                        !filterCustomerOrder.itemIdList.includes(item.id),
                    ),
                  ]}
                  getOptionLabel={(option) =>
                    `${option?.id || ""} - Buying: ${option?.buyingGrade || ""} - Sales: ${option?.salesGrade || ""} - ${
                      option?.crop || ""
                    }`
                  }
                  value={items.filter((item) =>
                    filterCustomerOrder.itemIdList.includes(item.id),
                  )}
                  onChange={(event, newValue) => {
                    setFilterCustomerOrder({
                      ...filterCustomerOrder,
                      itemIdList: newValue.map((item) => item.id),
                    });
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      style={{
                        ...props.style,
                        backgroundColor: selected ? "lightblue" : undefined,
                        fontWeight: selected ? 700 : 400,
                      }}
                    >
                      {`${option?.id || ""} - Buying: ${option?.buyingGrade || ""} - Sales: ${option?.salesGrade || ""} - ${
                        option?.crop || ""
                      }`}
                    </li>
                  )}
                  renderInput={(params) => {
                    const label =
                      filterCustomerOrder?.itemIdList.length > 0
                        ? `Items Selected (${filterCustomerOrder?.itemIdList.length})`
                        : "Item";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.item.inputValue}
                        onChange={(e) =>
                          updateComponentState("item", {
                            inputValue: e.target.value,
                          })
                        }
                        onMouseDown={retrieveItems}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("item", { dropdownOpen: false })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />

                <TextField
                  id="outlined-search"
                  label="Tobacco Code"
                  value={filterCustomerOrder?.tobaccoCode || ""}
                  type="search"
                  onChange={(e) =>
                    setFilterCustomerOrder({
                      ...filterCustomerOrder,
                      tobaccoCode: e.target.value,
                    })
                  }
                />

                <TextField
                  id="outlined-search"
                  label="Sales Grade"
                  value={filterCustomerOrder?.salesGrade || ""}
                  type="search"
                  onChange={(e) =>
                    setFilterCustomerOrder({
                      ...filterCustomerOrder,
                      salesGrade: e.target.value,
                    })
                  }
                />

                <TextField
                  id="outlined-search"
                  label="Buying Grade"
                  value={filterCustomerOrder?.buyingGrade || ""}
                  type="search"
                  onChange={(e) =>
                    setFilterCustomerOrder({
                      ...filterCustomerOrder,
                      buyingGrade: e.target.value,
                    })
                  }
                />

                <TextField
                  id="outlined-search"
                  label="Internal Grade"
                  value={filterCustomerOrder?.internalGrade || ""}
                  type="search"
                  onChange={(e) =>
                    setFilterCustomerOrder({
                      ...filterCustomerOrder,
                      internalGrade: e.target.value,
                    })
                  }
                />

                <FilterSelect
  label="Origin"
  menuType="origin"
  value={filterCustomerOrder.originList}
  onChange={(e) => setFilterCustomerOrder({
    ...filterCustomerOrder,
    originList: e.target.value
  })}
  multiple
/>

 <FilterSelect
  label="Type"
  menuType="type"
  value={filterCustomerOrder.typeList}
  onChange={(e) => setFilterCustomerOrder({
    ...filterCustomerOrder,
    typeList: e.target.value
  })}
  multiple
/>
  
<FilterSelect
  label="Leaf Form"
  menuType="leafForm"
  value={filterCustomerOrder.leafFormList}
  onChange={(e) => setFilterCustomerOrder({
    ...filterCustomerOrder,
    leafFormList: e.target.value
  })}
  multiple
/>

                <FilterSelect
  label="Color"
  menuType="color"
  value={filterCustomerOrder.colorList}
  onChange={(e) => setFilterCustomerOrder({
    ...filterCustomerOrder,
    colorList: e.target.value
  })}
  multiple
/>
                <ClickAwayListener
                  onClickAway={() => {
                    if (filterCustomerOrder?.showCropFields) {
                      setFilterCustomerOrder({
                        ...filterCustomerOrder,
                        showCropFields: false,
                      });
                    }
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <TextField
                      id="crop-year"
                      type="text"
                      label="Crop Year"
                      fullWidth
                      variant="outlined"
                      value={
                        filterCustomerOrder?.cropFrom && filterCustomerOrder?.cropTo
                          ? `${filterCustomerOrder.cropFrom} - ${filterCustomerOrder.cropTo}`
                          : filterCustomerOrder?.cropFrom
                            ? `From ${filterCustomerOrder.cropFrom}`
                            : filterCustomerOrder?.cropTo
                              ? `To ${filterCustomerOrder.cropTo}`
                              : ""
                      }
                      onFocus={() =>
                        setFilterCustomerOrder({
                          ...filterCustomerOrder,
                          showCropFields: true,
                        })
                      }
                    />
                    {filterCustomerOrder?.showCropFields && (
                      <Paper
                        elevation={3}
                        sx={{
                          position: "absolute",
                          mt: 1,
                          p: 2,
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          zIndex: 10,
                        }}
                      >
                        <TextField
                          id="crop-year-from"
                          type="number"
                          label="Crop Year From"
                          value={filterCustomerOrder?.cropFrom || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              cropFrom: e.target.value,
                            })
                          }
                        />
                        <TextField
                          id="crop-year-to"
                          type="number"
                          label="Crop Year To"
                          value={filterCustomerOrder?.cropTo || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              cropTo: e.target.value,
                            })
                          }
                        />
                        <Button
                          variant="contained"
                          sx={{ mt: 1, alignSelf: "center" }}
                          onClick={() =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              showCropFields: false,
                            })
                          }
                        >
                          Done
                        </Button>
                      </Paper>
                    )}
                  </Box>
                </ClickAwayListener>
                <TextField
                  label="Current Location"
                  type="search"
                  value={filterCustomerOrder?.itemStorage || ""}
                  id="outlined-storage"
                  onChange={(e) =>
                    setFilterCustomerOrder({
                      ...filterCustomerOrder,
                      itemStorage: e.target.value,
                    })
                  }
                />

<ClickAwayListener
                  onClickAway={() => {
                    if (filterCustomerOrder?.showNicotineFields) {
                      setFilterCustomerOrder({
                        ...filterCustomerOrder,
                        showNicotineFields: false,
                      });
                    }
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <TextField
                      id="nicotine"
                      type="text"
                      label="Nicotine"
                      fullWidth
                      variant="outlined"
                      value={
                        filterCustomerOrder?.nicotineFrom && filterCustomerOrder?.nicotineTo
                          ? `${filterCustomerOrder.nicotineFrom} - ${filterCustomerOrder.nicotineTo}`
                          : filterCustomerOrder?.nicotineFrom
                            ? `From ${filterCustomerOrder.nicotineFrom}`
                            : filterCustomerOrder?.nicotineTo
                              ? `To ${filterCustomerOrder.nicotineTo}`
                              : ""
                      }
                      onFocus={() =>
                        setFilterCustomerOrder({
                          ...filterCustomerOrder,
                          showNicotineFields: true,
                        })
                      }
                    />
                    {filterCustomerOrder?.showNicotineFields && (
                      <Paper
                        elevation={3}
                        sx={{
                          position: "absolute",
                          mt: 1,
                          p: 2,
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          zIndex: 10,
                        }}
                      >
                        <TextField
                          id="nicotine-from"
                          type="number"
                          label="Nicotine From"
                          value={filterCustomerOrder?.nicotineFrom || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              nicotineFrom: e.target.value,
                            })
                          }
                        />
                        <TextField
                          id="nicotine-to"
                          type="number"
                          label="Nicotine To"
                          value={filterCustomerOrder?.nicotineTo || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              nicotineTo: e.target.value,
                            })
                          }
                        />
                        <Button
                          variant="contained"
                          sx={{ mt: 1, alignSelf: "center" }}
                          onClick={() =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              showNicotineFields: false,
                            })
                          }
                        >
                          Done
                        </Button>
                      </Paper>
                    )}
                  </Box>
                </ClickAwayListener>

                <ClickAwayListener
                  onClickAway={() => {
                    if (filterCustomerOrder?.showSugarFields) {
                      setFilterCustomerOrder({
                        ...filterCustomerOrder,
                        showSugarFields: false,
                      });
                    }
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <TextField
                      id="sugar"
                      type="text"
                      label="Sugar"
                      fullWidth
                      variant="outlined"
                      value={
                        filterCustomerOrder?.sugarFrom && filterCustomerOrder?.sugarTo
                          ? `${filterCustomerOrder.sugarFrom} - ${filterCustomerOrder.sugarTo}`
                          : filterCustomerOrder?.sugarFrom
                            ? `From ${filterCustomerOrder.sugarFrom}`
                            : filterCustomerOrder?.sugarTo
                              ? `To ${filterCustomerOrder.sugarTo}`
                              : ""
                      }
                      onFocus={() =>
                        setFilterCustomerOrder({
                          ...filterCustomerOrder,
                          showSugarFields: true,
                        })
                      }
                    />
                    {filterCustomerOrder?.showSugarFields && (
                      <Paper
                        elevation={3}
                        sx={{
                          position: "absolute",
                          mt: 1,
                          p: 2,
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          zIndex: 10,
                        }}
                      >
                        <TextField
                          id="sugar-from"
                          type="number"
                          label="Sugar From"
                          value={filterCustomerOrder?.sugarFrom || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              sugarFrom: e.target.value,
                            })
                          }
                        />
                        <TextField
                          id="sugar-to"
                          type="number"
                          label="Sugar To"
                          value={filterCustomerOrder?.sugarTo || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              sugarTo: e.target.value,
                            })
                          }
                        />
                        <Button
                          variant="contained"
                          sx={{ mt: 1, alignSelf: "center" }}
                          onClick={() =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              showSugarFields: false,
                            })
                          }
                        >
                          Done
                        </Button>
                      </Paper>
                    )}
                  </Box>
                </ClickAwayListener>

                <TextField
                  id="outlined-number"
                  label="Warehouse"
                  value={filterCustomerOrder?.warehouse || ""}
                  onChange={(e) =>
                    setFilterCustomerOrder({
                      ...filterCustomerOrder,
                      warehouse: e.target.value,
                    })
                  }
                />
                <Autocomplete
                  multiple
                  id="outlined-select-customer"
                  disableClearable
                  open={componentsState.customer.dropdownOpen}
                  onOpen={() =>
                    updateComponentState("customer", { dropdownOpen: true })
                  }
                  inputValue={componentsState.customer.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("customer", {
                        inputValue: newInputValue,
                      });
                    }
                  }}
                  options={[
                    ...customers.filter((customer) =>
                      filterCustomerOrder.stakeholderIdList.includes(
                        customer.id,
                      ),
                    ),
                    ...customers.filter(
                      (customer) =>
                        !filterCustomerOrder.stakeholderIdList.includes(
                          customer.id,
                        ),
                    ),
                  ]}
                  getOptionLabel={(option) =>
                    `${option?.id || ""} - ${option?.name || ""}`
                  }
                  value={customers.filter((customer) =>
                    filterCustomerOrder.stakeholderIdList.includes(customer.id),
                  )}
                  onChange={(event, newValue) => {
                    setFilterCustomerOrder({
                      ...filterCustomerOrder,
                      stakeholderIdList: newValue.map(
                        (customer) => customer.id,
                      ),
                    });
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      style={{
                        ...props.style,
                        backgroundColor: selected ? "lightblue" : undefined,
                        fontWeight: selected ? 700 : 400,
                      }}
                    >
                      {`${option?.id || ""} - ${option?.name || ""}`}
                    </li>
                  )}
                  renderInput={(params) => {
                    const label =
                      filterCustomerOrder?.stakeholderIdList.length > 0
                        ? `Customers Selected (${filterCustomerOrder?.stakeholderIdList.length})`
                        : "Customer";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.customer.inputValue}
                        onChange={(e) =>
                          updateComponentState("customer", {
                            inputValue: e.target.value,
                          })
                        }
                        onMouseDown={retrieveCustomers}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("customer", {
                            dropdownOpen: false,
                          })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />
                
                <Autocomplete
                  multiple
                  id="outlined-select-second-sample"
                  disableClearable
                  open={componentsState.secondSample.dropdownOpen}
                  onOpen={() =>
                    updateComponentState("secondSample", { dropdownOpen: true })
                  }
                  inputValue={componentsState.secondSample.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("secondSample", {
                        inputValue: newInputValue,
                      });
                    }
                  }}
                  options={[
                    ...samples.filter((sample) =>
                      filterCustomerOrder.secondSampleIdList.includes(
                        sample.id,
                      ),
                    ),
                    ...samples.filter(
                      (sample) =>
                        !filterCustomerOrder.secondSampleIdList.includes(
                          sample.id,
                        ),
                    ),
                  ]}
                  getOptionLabel={(option) =>
                    `${option?.id || ""} - ${option?.remark || ""}`
                  }
                  value={samples.filter((sample) =>
                    filterCustomerOrder.secondSampleIdList.includes(sample.id),
                  )}
                  onChange={(event, newValue) => {
                    setFilterCustomerOrder({
                      ...filterCustomerOrder,
                      secondSampleIdList: newValue.map((sample) => sample.id),
                    });
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      style={{
                        ...props.style,
                        backgroundColor: selected ? "lightblue" : undefined,
                        fontWeight: selected ? 700 : 400,
                      }}
                    >
                      {`${option?.id || ""} - ${option?.remark || ""}`}
                    </li>
                  )}
                  renderInput={(params) => {
                    const label =
                      filterCustomerOrder?.secondSampleIdList.length > 0
                        ? `Redrawn Samples Selected (${filterCustomerOrder?.secondSampleIdList.length})`
                        : "Redrawn Sample";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.secondSample.inputValue}
                        onChange={(e) =>
                          updateComponentState("secondSample", {
                            inputValue: e.target.value,
                          })
                        }
                        onMouseDown={retrieveSamples}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("secondSample", {
                            dropdownOpen: false,
                          })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />

<FilterSelect
  label="Redrawn Sample Status"
  menuType="sampleStatus"
  value={filterCustomerOrder.secondSampleStatusList}
  onChange={(e) => setFilterCustomerOrder({
    ...filterCustomerOrder,
    secondSampleStatusList: e.target.value
  })}
  multiple
/>
<FilterSelect
  label="Packaging"
  menuType="packagingTypes"
  value={filterCustomerOrder.packagingList}
  onChange={(e) => setFilterCustomerOrder({
    ...filterCustomerOrder,
    packagingList: e.target.value
  })}
  multiple
/>
                <ClickAwayListener
                  onClickAway={() => {
                    if (filterCustomerOrder?.showNetWeightPerCaseFields) {
                      setFilterCustomerOrder({
                        ...filterCustomerOrder,
                        showNetWeightPerCaseFields: false,
                      });
                    }
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <TextField
                      id="net-weight-per-case"
                      type="text"
                      label="Net Weight Per Carton"
                      fullWidth
                      variant="outlined"
                      value={
                        filterCustomerOrder?.netWeightPerCaseFrom &&
                          filterCustomerOrder?.netWeightPerCaseTo
                          ? `${filterCustomerOrder.netWeightPerCaseFrom} - ${filterCustomerOrder.netWeightPerCaseTo}`
                          : filterCustomerOrder?.netWeightPerCaseFrom
                            ? `From ${filterCustomerOrder.netWeightPerCaseFrom}`
                            : filterCustomerOrder?.netWeightPerCaseTo
                              ? `To ${filterCustomerOrder.netWeightPerCaseTo}`
                              : ""
                      }
                      onFocus={() =>
                        setFilterCustomerOrder({
                          ...filterCustomerOrder,
                          showNetWeightPerCaseFields: true,
                        })
                      }
                    />
                    {filterCustomerOrder?.showNetWeightPerCaseFields && (
                      <Paper
                        elevation={3}
                        sx={{
                          position: "absolute",
                          mt: 1,
                          p: 2,
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          zIndex: 10,
                        }}
                      >
                        <TextField
                          id="net-weight-per-case-from"
                          type="number"
                          label="Net Weight Per Carton From"
                          value={filterCustomerOrder?.netWeightPerCaseFrom || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              netWeightPerCaseFrom: e.target.value,
                            })
                          }
                        />
                        <TextField
                          id="net-weight-per-case-to"
                          type="number"
                          label="Net Weight Per Carton To"
                          value={filterCustomerOrder?.netWeightPerCaseTo || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              netWeightPerCaseTo: e.target.value,
                            })
                          }
                        />
                        <Button
                          variant="contained"
                          sx={{ mt: 1, alignSelf: "center" }}
                          onClick={() =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              showNetWeightPerCaseFields: false,
                            })
                          }
                        >
                          Done
                        </Button>
                      </Paper>
                    )}
                  </Box>
                </ClickAwayListener>

                <ClickAwayListener
                  onClickAway={() => {
                    if (filterCustomerOrder?.showNumberOfCasesFields) {
                      setFilterCustomerOrder({
                        ...filterCustomerOrder,
                        showNumberOfCasesFields: false,
                      });
                    }
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <TextField
                      id="number-of-cases"
                      type="text"
                      label="Number Of Cartons"
                      fullWidth
                      variant="outlined"
                      value={
                        filterCustomerOrder?.numberOfCasesFrom && filterCustomerOrder?.numberOfCasesTo
                          ? `${filterCustomerOrder.numberOfCasesFrom} - ${filterCustomerOrder.numberOfCasesTo}`
                          : filterCustomerOrder?.numberOfCasesFrom
                            ? `From ${filterCustomerOrder.numberOfCasesFrom}`
                            : filterCustomerOrder?.numberOfCasesTo
                              ? `To ${filterCustomerOrder.numberOfCasesTo}`
                              : ""
                      }
                      onFocus={() =>
                        setFilterCustomerOrder({
                          ...filterCustomerOrder,
                          showNumberOfCasesFields: true,
                        })
                      }
                    />
                    {filterCustomerOrder?.showNumberOfCasesFields && (
                      <Paper
                        elevation={3}
                        sx={{
                          position: "absolute",
                          mt: 1,
                          p: 2,
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          zIndex: 10,
                        }}
                      >
                        <TextField
                          id="number-of-cases-from"
                          type="number"
                          label="Number Of Cartons From"
                          value={filterCustomerOrder?.numberOfCasesFrom || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              numberOfCasesFrom: e.target.value,
                            })
                          }
                        />
                        <TextField
                          id="number-of-cases-to"
                          type="number"
                          label="Number Of Cartons To"
                          value={filterCustomerOrder?.numberOfCasesTo || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              numberOfCasesTo: e.target.value,
                            })
                          }
                        />
                        <Button
                          variant="contained"
                          sx={{ mt: 1, alignSelf: "center" }}
                          onClick={() =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              showNumberOfCasesFields: false,
                            })
                          }
                        >
                          Done
                        </Button>
                      </Paper>
                    )}
                  </Box>
                </ClickAwayListener>

                <ClickAwayListener
                  onClickAway={() => {
                    if (filterCustomerOrder?.showVolumeFields) {
                      setFilterCustomerOrder({
                        ...filterCustomerOrder,
                        showVolumeFields: false,
                      });
                    }
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <TextField
                      id="quantity"
                      type="text"
                      label="Quantity"
                      fullWidth
                      variant="outlined"
                      value={
                        filterCustomerOrder?.volumeFrom && filterCustomerOrder?.volumeTo
                          ? `${filterCustomerOrder.volumeFrom} - ${filterCustomerOrder.volumeTo}`
                          : filterCustomerOrder?.volumeFrom
                            ? `From ${filterCustomerOrder.volumeFrom}`
                            : filterCustomerOrder?.volumeTo
                              ? `To ${filterCustomerOrder.volumeTo}`
                              : ""
                      }
                      onFocus={() =>
                        setFilterCustomerOrder({
                          ...filterCustomerOrder,
                          showVolumeFields: true,
                        })
                      }
                    />
                    {filterCustomerOrder?.showVolumeFields && (
                      <Paper
                        elevation={3}
                        sx={{
                          position: "absolute",
                          mt: 1,
                          p: 2,
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          zIndex: 10,
                        }}
                      >
                        <TextField
                          id="quantity-from"
                          type="number"
                          label="Quantity From"
                          value={filterCustomerOrder?.volumeFrom || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              volumeFrom: e.target.value,
                            })
                          }
                        />
                        <TextField
                          id="quantity-to"
                          type="number"
                          label="Quantity To"
                          value={filterCustomerOrder?.volumeTo || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              volumeTo: e.target.value,
                            })
                          }
                        />
                        <Button
                          variant="contained"
                          sx={{ mt: 1, alignSelf: "center" }}
                          onClick={() =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              showVolumeFields: false,
                            })
                          }
                        >
                          Done
                        </Button>
                      </Paper>
                    )}
                  </Box>
                </ClickAwayListener>

<FilterSelect
  label="Quantity Unit"
  menuType="units"
  value={filterCustomerOrder.volumeUnitList}
  onChange={(e) => setFilterCustomerOrder({
    ...filterCustomerOrder,
    volumeUnitList: e.target.value
  })}
  multiple
/>

                <ClickAwayListener
                  onClickAway={() => {
                    if (filterCustomerOrder?.showFirstPriceFields) {
                      setFilterCustomerOrder({
                        ...filterCustomerOrder,
                        showFirstPriceFields: false,
                      });
                    }
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <TextField
                      id="first-offer"
                      type="text"
                      label="First Offer"
                      fullWidth
                      variant="outlined"
                      value={
                        filterCustomerOrder?.firstPriceFrom &&
                          filterCustomerOrder?.firstPriceTo
                          ? `${filterCustomerOrder.firstPriceFrom} - ${filterCustomerOrder.firstPriceTo}`
                          : filterCustomerOrder?.firstPriceFrom
                            ? `From ${filterCustomerOrder.firstPriceFrom}`
                            : filterCustomerOrder?.firstPriceTo
                              ? `To ${filterCustomerOrder.firstPriceTo}`
                              : ""
                      }
                      onFocus={() =>
                        setFilterCustomerOrder({
                          ...filterCustomerOrder,
                          showFirstPriceFields: true,
                        })
                      }
                    />
                    {filterCustomerOrder?.showFirstPriceFields && (
                      <Paper
                        elevation={3}
                        sx={{
                          position: "absolute",
                          mt: 1,
                          p: 2,
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          zIndex: 10,
                        }}
                      >
                        <TextField
                          id="first-offer-from"
                          type="number"
                          label="First Offer From"
                          value={filterCustomerOrder?.firstPriceFrom || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              firstPriceFrom: e.target.value,
                            })
                          }
                        />
                        <TextField
                          id="first-offer-to"
                          type="number"
                          label="First Offer To"
                          value={filterCustomerOrder?.firstPriceTo || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              firstPriceTo: e.target.value,
                            })
                          }
                        />
                        <Button
                          variant="contained"
                          sx={{ mt: 1, alignSelf: "center" }}
                          onClick={() =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              showFirstPriceFields: false,
                            })
                          }
                        >
                          Done
                        </Button>
                      </Paper>
                    )}
                  </Box>
                </ClickAwayListener>


     <FilterSelect
  label="Currency" 
  menuType="currencies"
  value={filterCustomerOrder.firstPriceCurrencyList}
  onChange={(e) => setFilterCustomerOrder({
    ...filterCustomerOrder,
    firstPriceCurrencyList: e.target.value
  })}
  multiple
/>


                <ClickAwayListener
                  onClickAway={() => {
                    if (filterCustomerOrder?.showFinalPriceFields) {
                      setFilterCustomerOrder({
                        ...filterCustomerOrder,
                        showFinalPriceFields: false,
                      });
                    }
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <TextField
                      id="final-offer"
                      type="text"
                      label="Final Price"
                      fullWidth
                      variant="outlined"
                      value={
                        filterCustomerOrder?.finalPriceFrom &&
                          filterCustomerOrder?.finalPriceTo
                          ? `${filterCustomerOrder.finalPriceFrom} - ${filterCustomerOrder.finalPriceTo}`
                          : filterCustomerOrder?.finalPriceFrom
                            ? `From ${filterCustomerOrder.finalPriceFrom}`
                            : filterCustomerOrder?.finalPriceTo
                              ? `To ${filterCustomerOrder.finalPriceTo}`
                              : ""
                      }
                      onFocus={() =>
                        setFilterCustomerOrder({
                          ...filterCustomerOrder,
                          showFinalPriceFields: true,
                        })
                      }
                    />
                    {filterCustomerOrder?.showFinalPriceFields && (
                      <Paper
                        elevation={3}
                        sx={{
                          position: "absolute",
                          mt: 1,
                          p: 2,
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          zIndex: 10,
                        }}
                      >
                        <TextField
                          id="final-offer-from"
                          type="number"
                          label="Final Price From"
                          value={filterCustomerOrder?.finalPriceFrom || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              finalPriceFrom: e.target.value,
                            })
                          }
                        />
                        <TextField
                          id="final-offer-to"
                          type="number"
                          label="Final Price To"
                          value={filterCustomerOrder?.finalPriceTo || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              finalPriceTo: e.target.value,
                            })
                          }
                        />
                        <Button
                          variant="contained"
                          sx={{ mt: 1, alignSelf: "center" }}
                          onClick={() =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              showFinalPriceFields: false,
                            })
                          }
                        >
                          Done
                        </Button>
                      </Paper>
                    )}
                  </Box>
                </ClickAwayListener>

<FilterSelect
  label="Currency" 
  menuType="currencies"
  value={filterCustomerOrder.finalPriceCurrencyList}
  onChange={(e) => setFilterCustomerOrder({
    ...filterCustomerOrder,
    finalPriceCurrencyList: e.target.value
  })}
  multiple
/>

                <ClickAwayListener
                  onClickAway={() => {
                    if (filterCustomerOrder?.showTotalAmountFields) {
                      setFilterCustomerOrder({
                        ...filterCustomerOrder,
                        showTotalAmountFields: false,
                      });
                    }
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <TextField
                      id="total-amount"
                      type="text"
                      label="Total Amount"
                      fullWidth
                      variant="outlined"
                      value={
                        filterCustomerOrder?.totalAmountFrom && filterCustomerOrder?.totalAmountTo
                          ? `${filterCustomerOrder.totalAmountFrom} - ${filterCustomerOrder.totalAmountTo}`
                          : filterCustomerOrder?.totalAmountFrom
                            ? `From ${filterCustomerOrder.totalAmountFrom}`
                            : filterCustomerOrder?.totalAmountTo
                              ? `To ${filterCustomerOrder.totalAmountTo}`
                              : ""
                      }
                      onFocus={() =>
                        setFilterCustomerOrder({
                          ...filterCustomerOrder,
                          showTotalAmountFields: true,
                        })
                      }
                    />
                    {filterCustomerOrder?.showTotalAmountFields && (
                      <Paper
                        elevation={3}
                        sx={{
                          position: "absolute",
                          mt: 1,
                          p: 2,
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          zIndex: 10,
                        }}
                      >
                        <TextField
                          id="total-amount-from"
                          type="number"
                          label="Total Amount From"
                          value={filterCustomerOrder?.totalAmountFrom || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              totalAmountFrom: e.target.value,
                            })
                          }
                        />
                        <TextField
                          id="total-amount-to"
                          type="number"
                          label="Total Amount To"
                          value={filterCustomerOrder?.totalAmountTo || ""}
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              totalAmountTo: e.target.value,
                            })
                          }
                        />
                        <Button
                          variant="contained"
                          sx={{ mt: 1, alignSelf: "center" }}
                          onClick={() =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              showTotalAmountFields: false,
                            })
                          }
                        >
                          Done
                        </Button>
                      </Paper>
                    )}
                  </Box>
                </ClickAwayListener>

                <Autocomplete
                  multiple
                  id="outlined-select-cost"
                  disableClearable
                  open={componentsState.cost.dropdownOpen}
                  onOpen={() =>
                    updateComponentState("cost", { dropdownOpen: true })
                  }
                  inputValue={componentsState.cost.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("cost", {
                        inputValue: newInputValue,
                      });
                    }
                  }}
                  options={[
                    ...costs.filter((cost) =>
                      filterCustomerOrder.costIdList.includes(cost.id),
                    ),
                    ...costs.filter(
                      (cost) =>
                        !filterCustomerOrder.costIdList.includes(cost.id),
                    ),
                  ]}
                  getOptionLabel={(option) =>
                    `${option?.id || ""} - ${option?.remark || ""} - ${
                      option?.totalCost || ""
                    }`
                  }
                  value={costs.filter((cost) =>
                    filterCustomerOrder.costIdList.includes(cost.id),
                  )}
                  onChange={(event, newValue) => {
                    setFilterCustomerOrder({
                      ...filterCustomerOrder,
                      costIdList: newValue.map((cost) => cost.id),
                    });
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      style={{
                        ...props.style,
                        backgroundColor: selected ? "lightblue" : undefined,
                        fontWeight: selected ? 700 : 400,
                      }}
                    >
                      {`${option?.id || ""} - ${option?.remark || ""} - ${
                        option?.totalCost || ""
                      }`}
                    </li>
                  )}
                  renderInput={(params) => {
                    const label =
                      filterCustomerOrder?.costIdList.length > 0
                        ? `Costs Selected (${filterCustomerOrder?.costIdList.length})`
                        : "Cost";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.cost.inputValue}
                        onChange={(e) =>
                          updateComponentState("cost", {
                            inputValue: e.target.value,
                          })
                        }
                        onMouseDown={retrieveCosts}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("cost", { dropdownOpen: false })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />

                <ClickAwayListener
                  onClickAway={() => {
                    if (filterCustomerOrder?.showContractValueDateFields) {
                      setFilterCustomerOrder({
                        ...filterCustomerOrder,
                        showContractValueDateFields: false,
                      });
                    }
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <TextField
                      id="contract-value-date"
                      type="text"
                      label="Contract Value Date"
                      fullWidth
                      variant="outlined"
                      value={
                        filterCustomerOrder?.contractValueDateFrom &&
                          filterCustomerOrder?.contractValueDateTo
                          ? `${filterCustomerOrder.contractValueDateFrom}, ${filterCustomerOrder.contractValueDateTo}`
                          : filterCustomerOrder?.contractValueDateFrom
                            ? `From ${filterCustomerOrder.contractValueDateFrom}`
                            : filterCustomerOrder?.contractValueDateTo
                              ? `To ${filterCustomerOrder.contractValueDateTo}`
                              : ""
                      }
                      onFocus={() =>
                        setFilterCustomerOrder({
                          ...filterCustomerOrder,
                          showContractValueDateFields: true,
                        })
                      }
                    />
                    {filterCustomerOrder?.showContractValueDateFields && (
                      <Paper
                        elevation={3}
                        sx={{
                          position: "absolute",
                          mt: 1,
                          p: 2,
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          zIndex: 10,
                        }}
                      >
                        <TextField
                          id="contract-value-date-from"
                          type="date"
                          label="From"
                          value={filterCustomerOrder?.contractValueDateFrom || ""}
                          inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                          InputLabelProps={{ shrink: true }}
                          onKeyDown={(e) => e.preventDefault()}
                          onChange={(e) =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              contractValueDateFrom: e.target.value,
                            })
                          }
                        />
                        <TextField
                          id="contract-value-date-to"
                          type="date"
                          label="To"
                          value={filterCustomerOrder?.contractValueDateTo || ""}
                          inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                          InputLabelProps={{ shrink: true }}
                          onKeyDown={(e) => e.preventDefault()}
                          onChange={(e) =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              contractValueDateTo: e.target.value,
                            })
                          }
                        />
                        <Button
                          variant="contained"
                          sx={{ mt: 1, alignSelf: "center" }}
                          onClick={() =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              showContractValueDateFields: false,
                            })
                          }
                        >
                          Done
                        </Button>
                      </Paper>
                    )}
                  </Box>
                </ClickAwayListener>

<ClickAwayListener
  onClickAway={() => {
    if (filterCustomerOrder?.showOperationDateFields) {
      setFilterCustomerOrder({
        ...filterCustomerOrder,
        showOperationDateFields: false,
      });
    }
  }}
>
  <Box sx={{ position: "relative" }}>
    <TextField
      id="operation-date"
      type="text" 
      label="Issue Date"
      fullWidth
      variant="outlined"
      value={
        filterCustomerOrder?.operationDateFrom &&
          filterCustomerOrder?.operationDateTo
          ? `${filterCustomerOrder.operationDateFrom}, ${filterCustomerOrder.operationDateTo}`
          : filterCustomerOrder?.operationDateFrom
            ? `From ${filterCustomerOrder.operationDateFrom}`
            : filterCustomerOrder?.operationDateTo
              ? `To ${filterCustomerOrder.operationDateTo}`
              : ""
      }
      onFocus={() =>
        setFilterCustomerOrder({
          ...filterCustomerOrder,
          showOperationDateFields: true,
        })
      }
    />
    {filterCustomerOrder?.showOperationDateFields && (
      <Paper
        elevation={3}
        sx={{
          position: "absolute",
          mt: 1,
          p: 2,
          display: "flex",
          flexDirection: "column",
          gap: 2,
          zIndex: 10,
        }}
      >
        <TextField
          id="operation-date-from"
          type="date"
          label="From"
          value={filterCustomerOrder?.operationDateFrom || ""}
          inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
          InputLabelProps={{ shrink: true }}
          onKeyDown={(e) => e.preventDefault()}
          onChange={(e) =>
            setFilterCustomerOrder({
              ...filterCustomerOrder,
              operationDateFrom: e.target.value,
            })
          }
        />
        <TextField
          id="operation-date-to"
          type="date"
          label="To"
          value={filterCustomerOrder?.operationDateTo || ""}
          inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
          InputLabelProps={{ shrink: true }}
          onKeyDown={(e) => e.preventDefault()}
          onChange={(e) =>
            setFilterCustomerOrder({
              ...filterCustomerOrder,
              operationDateTo: e.target.value,
            })
          }
        />
        <Button
          variant="contained"
          sx={{ mt: 1, alignSelf: "center" }}
          onClick={() =>
            setFilterCustomerOrder({
              ...filterCustomerOrder,
              showOperationDateFields: false,
            })
          }
        >
          Done
        </Button>
      </Paper>
    )}
  </Box>
</ClickAwayListener>
<FilterSelect
  label="Incoterm"
  menuType="incoterms" 
  value={filterCustomerOrder.incotermList}
  onChange={(e) => setFilterCustomerOrder({
    ...filterCustomerOrder,
    incotermList: e.target.value
  })}
  multiple
/>
<FilterSelect
  label="Port Of Loading"
  menuType="portsOfLoading" 
  value={filterCustomerOrder.portOfLoadingList}
  onChange={(e) => setFilterCustomerOrder({
    ...filterCustomerOrder,
    portOfLoadingList: e.target.value
  })}
  multiple
/>

 <FilterSelect
  label="Port Of Discharge"
  menuType="portsOfDischarge" 
  value={filterCustomerOrder.portOfDischargeList}
  onChange={(e) => setFilterCustomerOrder({
    ...filterCustomerOrder,
    portOfDischargeList: e.target.value
  })}
  multiple
/>

 <FilterSelect
  label="Payment Term"
  menuType="paymentTerm" 
  value={filterCustomerOrder.paymentTermList}
  onChange={(e) => setFilterCustomerOrder({
    ...filterCustomerOrder,
    paymentTermList: e.target.value
  })}
  multiple
/>

<ClickAwayListener
                  onClickAway={() => {
                    if (filterCustomerOrder?.showEstimatedTimeOfDepartureFields) {
                      setFilterCustomerOrder({
                        ...filterCustomerOrder,
                        showEstimatedTimeOfDepartureFields: false,
                      });
                    }
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <TextField
                      id="estimatedTimeOfDeparture"
                      type="text"
                      label="ETD"
                      fullWidth
                      variant="outlined"
                      value={
                        filterCustomerOrder?.estimatedTimeOfDepartureFrom && filterCustomerOrder?.estimatedTimeOfDepartureTo
                          ? `${filterCustomerOrder.estimatedTimeOfDepartureFrom}, ${filterCustomerOrder.estimatedTimeOfDepartureTo}`
                          : filterCustomerOrder?.estimatedTimeOfDepartureFrom
                            ? `From ${filterCustomerOrder.estimatedTimeOfDepartureFrom}`
                            : filterCustomerOrder?.estimatedTimeOfDepartureTo
                              ? `To ${filterCustomerOrder.estimatedTimeOfDepartureTo}`
                              : ""
                      }
                      onFocus={() =>
                        setFilterCustomerOrder({
                          ...filterCustomerOrder,
                          showEstimatedTimeOfDepartureFields: true,
                        })
                      }
                    />
                    {filterCustomerOrder?.showEstimatedTimeOfDepartureFields && (
                      <Paper
                        elevation={3}
                        sx={{
                          position: "absolute",
                          mt: 1,
                          p: 2,
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          zIndex: 10,
                        }}
                      >
                        <TextField
                          id="estimatedTimeOfDeparture-from"
                          type="date"
                          label="From"
                          value={filterCustomerOrder?.estimatedTimeOfDepartureFrom || ""}
                          inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                          InputLabelProps={{ shrink: true }}
                          onKeyDown={(e) => e.preventDefault()}
                          onChange={(e) =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              estimatedTimeOfDepartureFrom: e.target.value,
                            })
                          }
                        />
                        <TextField
                          id="estimatedTimeOfDeparture-to"
                          type="date"
                          label="To"
                          value={filterCustomerOrder?.estimatedTimeOfDepartureTo || ""}
                          inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                          InputLabelProps={{ shrink: true }}
                          onKeyDown={(e) => e.preventDefault()}
                          onChange={(e) =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              estimatedTimeOfDepartureTo: e.target.value,
                            })
                          }
                        />
                        <Button
                          variant="contained"
                          sx={{ mt: 1, alignSelf: "center" }}
                          onClick={() =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              showEstimatedTimeOfDepartureFields: false,
                            })
                          }
                        >
                          Done
                        </Button>
                      </Paper>
                    )}
                  </Box>
                </ClickAwayListener>

                <ClickAwayListener
                  onClickAway={() => {
                    if (filterCustomerOrder?.showEstimatedTimeOfArrivalFields) {
                      setFilterCustomerOrder({
                        ...filterCustomerOrder,
                        showEstimatedTimeOfArrivalFields: false,
                      });
                    }
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <TextField
                      id="estimatedTimeOfArrival"
                      type="text"
                      label="ETA"
                      fullWidth
                      variant="outlined"
                      value={
                        filterCustomerOrder?.estimatedTimeOfArrivalFrom && filterCustomerOrder?.estimatedTimeOfArrivalTo
                          ? `${filterCustomerOrder.estimatedTimeOfArrivalFrom}, ${filterCustomerOrder.estimatedTimeOfArrivalTo}`
                          : filterCustomerOrder?.estimatedTimeOfArrivalFrom
                            ? `From ${filterCustomerOrder.estimatedTimeOfArrivalFrom}`
                            : filterCustomerOrder?.estimatedTimeOfArrivalTo
                              ? `To ${filterCustomerOrder.estimatedTimeOfArrivalTo}`
                              : ""
                      }
                      onFocus={() =>
                        setFilterCustomerOrder({
                          ...filterCustomerOrder,
                          showEstimatedTimeOfArrivalFields: true,
                        })
                      }
                    />
                    {filterCustomerOrder?.showEstimatedTimeOfArrivalFields && (
                      <Paper
                        elevation={3}
                        sx={{
                          position: "absolute",
                          mt: 1,
                          p: 2,
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          zIndex: 10,
                        }}
                      >
                        <TextField
                          id="estimatedTimeOfArrival-from"
                          type="date"
                          label="From"
                          value={filterCustomerOrder?.estimatedTimeOfArrivalFrom || ""}
                          inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                          InputLabelProps={{ shrink: true }}
                          onKeyDown={(e) => e.preventDefault()}
                          onChange={(e) =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              estimatedTimeOfArrivalFrom: e.target.value,
                            })
                          }
                        />
                        <TextField
                          id="estimatedTimeOfArrival-to"
                          type="date"
                          label="To"
                          value={filterCustomerOrder?.estimatedTimeOfArrivalTo || ""}
                          inputProps={{ min: "1999-01-01", max: "2999-01-01" }}
                          InputLabelProps={{ shrink: true }}
                          onKeyDown={(e) => e.preventDefault()}
                          onChange={(e) =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              estimatedTimeOfArrivalTo: e.target.value,
                            })
                          }
                        />
                        <Button
                          variant="contained"
                          sx={{ mt: 1, alignSelf: "center" }}
                          onClick={() =>
                            setFilterCustomerOrder({
                              ...filterCustomerOrder,
                              showEstimatedTimeOfArrivalFields: false,
                            })
                          }
                        >
                          Done
                        </Button>
                      </Paper>
                    )}
                  </Box>
                </ClickAwayListener>

                <Autocomplete
                  multiple
                  id="outlined-select-reservation"
                  disableClearable
                  open={componentsState.reservation.dropdownOpen}
                  onOpen={() =>
                    updateComponentState("reservation", { dropdownOpen: true })
                  }
                  inputValue={componentsState.reservation.inputValue}
                  onInputChange={(event, newInputValue, reason) => {
                    if (reason === "input") {
                      updateComponentState("reservation", {
                        inputValue: newInputValue,
                      });
                    }
                  }}
                  options={[
                    ...reservations.filter((reservation) =>
                      filterCustomerOrder.reservationIdList.includes(reservation.id),
                    ),
                    ...reservations.filter(
                      (reservation) =>
                        !filterCustomerOrder.reservationIdList.includes(reservation.id),
                    ),
                  ]}
                  getOptionLabel={(option) =>
                    `${option?.id || ""} - Buying: ${option?.offer?.item?.id || ""}`
                  }
                  value={reservations.filter((reservation) =>
                    filterCustomerOrder.reservationIdList.includes(reservation.id),
                  )}
                  onChange={(event, newValue) => {
                    setFilterCustomerOrder({
                      ...filterCustomerOrder,
                      reservationIdList: newValue.map((reservation) => reservation.id),
                    });
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li
                      {...props}
                      style={{
                        ...props.style,
                        backgroundColor: selected ? "lightblue" : undefined,
                        fontWeight: selected ? 700 : 400,
                      }}
                    >
                      {`${option?.id || ""} - Buying: ${option?.offer?.item?.id || ""}`}
                    </li>
                  )}
                  renderInput={(params) => {
                    const label =
                      filterCustomerOrder?.reservationIdList.length > 0
                        ? `Reservations Selected (${filterCustomerOrder?.reservationIdList.length})`
                        : "Reservation";

                    return (
                      <TextField
                        {...params}
                        label={label}
                        type="search"
                        value={componentsState.reservation.inputValue}
                        onChange={(e) =>
                          updateComponentState("reservation", {
                            inputValue: e.target.value,
                          })
                        }
                        onMouseDown={retrieveReservations}
                        InputProps={{
                          ...params.InputProps,
                          style: { height: 42 },
                        }}
                        onBlur={() =>
                          updateComponentState("reservation", { dropdownOpen: false })
                        }
                      />
                    );
                  }}
                  renderTags={() => null}
                />

                <TextField
                  id="outlined-search"
                  label="Shipment Schedule"
                  value={filterCustomerOrder?.shipmentSchedule || ""}
                  type="search"
                  onChange={(e) =>
                    setFilterCustomerOrder({
                      ...filterCustomerOrder,
                      shipmentSchedule: e.target.value,
                    })
                  }
                />
                <TextField
                  id="outlined-search"
                  label="Remark"
                  value={filterCustomerOrder?.remark || ""}
                  type="search"
                  onChange={(e) =>
                    setFilterCustomerOrder({
                      ...filterCustomerOrder,
                      remark: e.target.value,
                    })
                  }
                />
                <TextField
                  id="outlined-search"
                  label="Comment"
                  value={filterCustomerOrder?.comment || ""}
                  type="search"
                  onChange={(e) =>
                    setFilterCustomerOrder({
                      ...filterCustomerOrder,
                      comment: e.target.value,
                    })
                  }
                />
                <FilterSelect
  label="Order Status"
  menuType="orderStatus"
  value={filterCustomerOrder.orderStatusList}
  onChange={(e) => setFilterCustomerOrder({
    ...filterCustomerOrder,
    orderStatusList: e.target.value
  })}
  multiple
/>
  
   <FilterSelect
  label="Record Status"
  menuType="recordStatus" 
  value={filterCustomerOrder.recordStatusList}
  onChange={(e) => setFilterCustomerOrder({
    ...filterCustomerOrder,
    recordStatusList: e.target.value
  })}
  multiple
/>
     <MyFilters
    componentName="CustomerOrderView"
    filterState={filterCustomerOrder}
    onApply={(saved) => setFilterCustomerOrder(saved)}
  />

              </Grid>
              <Grid
                container
                spacing={2}
                justifyContent="flex-start"
                alignItems="center"
              >
                <Grid item xs={3} sm={1}>
                  <Button
                    disableElevation
                    variant="contained"
                    fullWidth
                    size="small"
                    onClick={() => {
                      retrieveFastFilteredOrdersApi(filterCustomerOrder)
                        .then((response) => {
                          setRows(response?.data);
                        })
                        .catch((error) => {
                          console.log(error?.response?.data);
                        });
                    }}
                  >
                    Search
                  </Button>
                </Grid>
                <Grid item xs={3} sm={1}>
                  <Button
                    disableElevation
                    variant="outlined"
                    fullWidth
                    size="small"
                    onClick={() => {
                      setFilterCustomerOrder({
                        id: 0,
                        orderType: "CUSTOMER",
                        stakeHolderType: "CUSTOMER",
                        itemBuyingGrade: "",
                        itemIdList: [],
                        stakeholderIdList: [],
                        costIdList: [],
                        offerIdList: [],
                        companyList: [],
                        approvalStatusList: [],
                        orderStatusList: [],
                        customerList: [],
                        firstSampleId: "",
                        secondSampleId: "",
                        costId: "",
                        firstSampleStatusList: [],
                        secondSampleStatusList: [],
                        paymentTerm: "",
                        paymentTermList: [],
                        incotermList: [],
                        portOfLoadingList: [],
                        portOfDischargeList: [],
                        packagingList: [],
                        volumeUnitList: [],
                        firstPriceCurrencyList: [],
                        finalPriceCurrencyList: [],
                        remark: "",
                        shipmentSchedule: "",
                        comment: "",
                        documentStatusList: [],
                        tobaccoCode: "",
                        salesGrade: "",
                        crop: null,
                        cropFrom: null,
                        cropTo: null,
                        nicotine: null,
                        nicotineFrom: null,
                        nicotineTo: null,
                        sugar: null,
                        sugarFrom: null,
                        sugarTo: null,
                        moisture: null,
                        warehouse: null,
                        volume: null,
                        volumeFrom: null,
                        volumeTo: null,
                        netWeightPerCase: null,
                        netWeightPerCaseFrom: null,
                        netWeightPerCaseTo: null,
                        numberOfCases: null,
                        numberOfCasesFrom: null,
                        numberOfCasesTo: null,
                        quantity: null,
                        firstPrice: null,
                        firstPriceFrom: null,
                        firstPriceTo: null,
                        finalPrice: null,
                        finalPriceFrom: null,
                        finalPriceTo: null,
                        totalAmount: null,
                        totalAmountFrom: null,
                        totalAmountTo: null,
                        statusDeadline: null,
                        contractValueDate: null,
                        contractValueDateFrom: null,
                        contractValueDateTo: null,
                        operationDate: null,
                        operationDateFrom: null,
                        operationDateTo: null,
                        estimatedTimeOfDeparture: null,
                        estimatedTimeOfDepartureFrom: null,
                        estimatedTimeOfDepartureTo: null,
                        estimatedTimeOfArrival: null,
                        estimatedTimeOfArrivalFrom: null,
                        estimatedTimeOfArrivalTo: null,
                        orderGroupNumber: null,
                        firstSampleIdList: [],
                        secondSampleIdList: [],
                        buyingGrade: "",
                        customerGrade: "",
                        internalGrade: "",
                        originList: [],
                        typeList: [],
                        leafFormList: [],
                        colorList: [],
                        storageList: [],
                        reservationIdList: [],
                        itemStorage: "",
                        recordStatusList: ["ACTIVE"],
                        orderIdList: [],
                      });
                    }}
                  >
                    Clear Filters
                  </Button>
                </Grid>
              </Grid>
              <br></br>
            </Box>
          )}

          <Box sx={{ width: "100%" }}>
            <Paper sx={{ width: "100%", mb: 2 }}>
              <EnhancedTableToolbar
                numSelected={selected.length}
                showFilters={showFilters}
                setShowFilters={setShowFilters}
                rows={rows}
                setAddView={setAddView}
                selected={selected}
                setExportSoPopup={setExportSoPopup}
                setExportProformaDetailsPopup={setExportProformaDetailsPopup}
                exportSoPopup={exportSoPopup}
                selectedData={selectedData}
                visibleColumns={visibleColumns}
                setVisibleColumns={setVisibleColumns}
                selectedColumns = {selectedColumns}
                setSelectedColumns = {setSelectedColumns}
                selectColumnsDialogOpen={selectColumnsDialogOpen}
                setSelectColumnsDialogOpen={setSelectColumnsDialogOpen}
                columnsOrder = {columnsOrder}
                setColumnsOrder = {setColumnsOrder}
                onOpenBulkAssignDialog={openBulkAssignDialog}
                onOpenBulkApproveDialog={openBulkApproveDialog}
              />
              <Dialog open={isBulkAssignDialogOpen} onClose={closeBulkAssignDialog} maxWidth="md" fullWidth>
                <DialogTitle>Assign Selected Sales Orders</DialogTitle>
                <DialogContent>
                  <Typography sx={{ mb: 1 }}>
                    You are assigning {selectedData.length} order(s). Review details below before confirming.
                  </Typography>
                  <Select
                    fullWidth
                    size="small"
                    value={bulkSelectedUser}
                    onChange={(e) => setBulkSelectedUser(e.target.value)}
                    sx={{ mb: 2 }}
                  >
                    <MenuItem value="">Select a User</MenuItem>
                    {users.map((option) => (
                      <MenuItem key={option.id} value={option}>
                        {option.name}
                      </MenuItem>
                    ))}
                  </Select>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>ID</TableCell>
                        <TableCell>Order Number</TableCell>
                        <TableCell>Customer</TableCell>
                        <TableCell>Item</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Current Assignee</TableCell>
                        <TableCell>Approval</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {selectedData.map((row) => (
                        <TableRow key={row.id}>
                          <TableCell>{row.id}</TableCell>
                          <TableCell>{(row?.orderYear ? `${row.orderYear}-` : "") + (row?.orderGroupNumber || "")}</TableCell>
                          <TableCell>{row?.stakeholderName || "-"}</TableCell>
                          <TableCell>{row?.offerItemBuyingGrade || row?.offerItemTobaccoCode || "-"}</TableCell>
                          <TableCell>{row?.orderStatus || "N/A"}</TableCell>
                          <TableCell>{row?.assignedUserName || "Unassigned"}</TableCell>
                          <TableCell>{row?.approvalStatus || "N/A"}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </DialogContent>
                <DialogActions>
                  <Button onClick={closeBulkAssignDialog}>Cancel</Button>
                  <Button onClick={handleBulkAssignment} disabled={!bulkSelectedUser}>Assign</Button>
                </DialogActions>
              </Dialog>
              <Dialog open={isBulkApproveDialogOpen} onClose={closeBulkApproveDialog} maxWidth="md" fullWidth>
                <DialogTitle>Approve Selected Sales Orders</DialogTitle>
                <DialogContent>
                  <Typography sx={{ mb: 2 }}>
                    You are approving {selectedData.length} order(s). Review details below before confirming.
                  </Typography>
                  <TableContainer component={Paper}
                    sx={{
                      border: "2px solid #d1dfe8",
                      borderRadius: "8px",
                      overflow: "hidden",
                    }}>
                  <Table size="small" sx={{ tableLayout: "fixed", width: "100%" }}>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ backgroundColor: "#98c1d9", textAlign: "center" }}>Order ID</TableCell>
                        <TableCell sx={{ backgroundColor: "#98c1d9", textAlign: "center" }}>SAP Number</TableCell>
                        <TableCell sx={{ backgroundColor: "#98c1d9", textAlign: "center" }}>Customer</TableCell>
                        <TableCell sx={{ backgroundColor: "#98c1d9", textAlign: "center" }}>Buying Grade</TableCell>
                        <TableCell sx={{ backgroundColor: "#98c1d9", textAlign: "center" }}>Volume</TableCell>
                        <TableCell sx={{ backgroundColor: "#98c1d9", textAlign: "center" }}>Status</TableCell>
                        <TableCell sx={{ backgroundColor: "#98c1d9", textAlign: "center" }}>Assigned To</TableCell>
                        <TableCell sx={{ backgroundColor: "#98c1d9", textAlign: "center" }}>Approval</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {selectedData.map((row) => (
                        <TableRow key={row.id}>
                          <TableCell><TextField size="small" fullWidth disabled value={row?.id || ""} /></TableCell>
                          <TableCell><TextField size="small" fullWidth disabled value={row?.salesOrderNumber || ""} /></TableCell>
                          <TableCell><TextField size="small" fullWidth disabled value={row?.stakeholderName || ""} /></TableCell>
                          <TableCell><TextField size="small" fullWidth disabled value={row?.offerItemBuyingGrade || ""} /></TableCell>
                          <TableCell><TextField size="small" fullWidth disabled value={row?.volume || ""} /></TableCell>
                          <TableCell><TextField size="small" fullWidth disabled value={row?.orderStatus || "N/A"} /></TableCell>
                          <TableCell><TextField size="small" fullWidth disabled value={row?.assignedUserName || "Unassigned"} /></TableCell>
                          <TableCell><TextField size="small" fullWidth disabled value={row?.approvalStatus || "N/A"} /></TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  </TableContainer>
                </DialogContent>
                <DialogActions>
                  <Button onClick={closeBulkApproveDialog}>Cancel</Button>
                  <Button onClick={handleBulkApprove}>Approve</Button>
                </DialogActions>
              </Dialog>
                        <CustomerOrderTable
                   visibleRows={visibleRows}
                   dense={dense}
                   isSelected={isSelected}
                   handleClick={handleClick}
                   emptyRows={emptyRows}
                   visibleColumns={visibleColumns}
                   onSelectAllClick={handleSelectAllClick}
                   order={order}
                   orderBy={orderBy}
                   onRequestSort={handleRequestSort}
                   numSelected={selected.length}
                   rowCount={rows.length}
                   setShowButtons={setShowButtons}
                   showButtons={showButtons}
                   setEditCustomerOrder={setEditCustomerOrder}
                   approveOrder={approveOrder}
                   setOrderData={setOrderData}
                   openDeclineDialog={openDeclineDialog}
                   isDeclineDialogOpen={isDeclineDialogOpen}
                   closeDeclineDialog={closeDeclineDialog}
                   declineNote={declineNote}
                   handleDecline={handleDecline}
                   openAssignUserDialog={openAssignUserDialog}
                   isAssignUserDialogOpen={isAssignUserDialogOpen}
                   closeAssignUserDialog={closeAssignUserDialog}
                   selectedUser={selectedUser}
                   setSelectedUser={setSelectedUser}
                   selectedRow={selectedRow}
                   users={users}
                   handleAssignment={handleAssignment}
                   setShowShipmentRequestPopup={setShowShipmentRequestPopup}
                   loadingRecord={loadingRecord}
                   cancelOrder={cancelOrder}
                  setEditItem={setEditItem}
                  setEditSample={setEditSample}
                  setEditCustomerOffer={setEditCustomerOffer}
                  user={user}
                />
              {/*<TableContainer style={{ maxHeight: 700 }}>
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  striped="columns"
                  style={{ width: "max-content" }}
                  sx={{
                    minWidth: 750,
                    "& .MuiTableCell-root": {
                      borderRight: "1px solid rgba(224, 224, 224, 1)",
                    },
                    "& .MuiTableCell-head": {
                      backgroundColor: "#20315d",
                      color: "white",
                      borderRight: "1px solid rgba(49, 64, 128, 1)",
                    },
                  }}
                  aria-labelledby="tableTitle"
                  size={dense ? "small" : "medium"}
                >
                  <EnhancedTableHead
                    numSelected={selected.length}
                    order={order}
                    orderBy={orderBy}
                    onSelectAllClick={handleSelectAllClick}
                    onRequestSort={handleRequestSort}
                    rowCount={rows.length}
                    showButtons={showButtons}
                  />
                  <TableBody>
                    {visibleRows.map((row, index) => {
                      const isItemSelected = isSelected(row.id);
                      const labelId = `enhanced-table-checkbox-${index}`;

                      return (
                        <TableRow
                          style={
                            isSelected(row.id) ? { background: "#d7e7fc" }
                            : row.orderStatus === "SO Created"
                            ? { background: "#c8e6d2" }
                            : (row.orderStatus === "Closed" || !row.remainingQuantity)
                            ? { background: "#FFCDD2" }
                            :index % 2
                              ? { background: "#f0f0f0" }
                              : { background: "white" }
                          }
                          hover
                          onClick={(event) => handleClick(event, row.id, row)}
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={row.id}
                          selected={isItemSelected}
                          sx={{ cursor: "pointer" }}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox
                              color="primary"
                              checked={isItemSelected}
                              inputProps={{
                                "aria-labelledby": labelId,
                              }}
                            />
                          </TableCell>
                          <TableCell padding="normal"
                           sx={{
                            position: "sticky",
                            left: 0,
                            background: "inherit",
                            zIndex: 2,
                            display: "flex", alignItems: "center"
                          }}>
                            <TradeHistoryButton row={row} />
                            <IconButton
                               onClick={(e) => {
                                e.stopPropagation();
                                setShowButtons(!showButtons);
                              }}
                            >
                              <ArrowForwardIosIcon
                                style={{
                                  transform: showButtons
                                    ? "rotate(180deg)"
                                    : "rotate(0deg)",
                                }}
                              />
                            </IconButton>
                            {showButtons && (
                              <div
                                style={{
                                  display: "flex",
                                  gap: "10px",
                                  marginLeft: "10px",
                                }}
                              >
                            <Button
                            disabled={row?.orderStatus==="Cancelled"}
                              onClick={(e) => {
                                setEditCustomerOrder({
                                  visible: true,
                                  data: row,
                                  index: index,
                                });
                                e.preventDefault();
                              }}
                            >
                              Edit
                            </Button>

                            <Tooltip title="Approve Order">
                            <ApproveOrderButton
                               row={row}
                               approveOrder={approveOrder}>
                            </ApproveOrderButton>
</Tooltip>
<Tooltip title="Decline Order">
  <IconButton
    color="secondary"
    disabled={
      row?.approvalStatus === "Declined" ||
      row?.orderStatus === "Cancelled" ||
      !row?.assignedUserId
    }
    onClick={() => {
      if (localStorage.getItem("username") === row?.assignedUserEmail) {
         retrieveOrderByIdApi(row?.id)
           .then((response) => {
             setOrderData(response?.data);
             openDeclineDialog(response?.data);
           })
           .catch((error) => {
             window.alert("Failed to retrieve order. Please try again later.");
           });
      } else {
        toast.error("This order is not assigned to you.");
      }
    }}
  >
    <CancelIcon />
  </IconButton>
</Tooltip>
<Dialog
                            open={isDeclineDialogOpen}
                            onClose={closeDeclineDialog}
                          >
                            <DialogTitle>
                              Decline Order
                            </DialogTitle>
                            <DialogContent>
                            <Typography variant="body2">Decline Note</Typography>
                                        <TextField
                                          variant="outlined"
                                          size="small"
                                          fullWidth
                                          value={declineNote}
                                          onChange={(e) =>
                                            declineNote = e.target.value
                                          }
                                        />
                            </DialogContent>
                            <DialogActions>
                              <Button onClick={closeDeclineDialog}>
                                Cancel
                              </Button>
                              <Button
                                onClick={handleDecline}
                              >
                                Save
                              </Button>
                            </DialogActions>
                          </Dialog>

                            <Button
                              variant="outlined"
                              disabled={row?.approvalStatus === "Approved"}
                              onClick={(e) => {
                                  e.stopPropagation();
                                  retrieveOrderByIdApi(row?.id)
                                  .then((response) => {
                                    setOrderData(response?.data);
                                    openAssignUserDialog(response?.data);
                                  })
                                  .catch((error) => {
                                    window.alert("Failed to retrieve order. Please try again later.");
                                  });
                                }}
                            >
                              Assign
                            </Button>

                          <Dialog
                            open={isAssignUserDialogOpen}
                            onClose={closeAssignUserDialog}
                          >
                            <DialogTitle>
                              Assign Order to a User
                            </DialogTitle>
                            <DialogContent>
                              <Select
                                value={selectedUser}
                                onChange={(e) =>
                                  setSelectedUser(e.target.value)
                                }
                                displayEmpty
                                fullWidth
                              >
                                <MenuItem value="" disabled>
                                  {selectedRow?.assignedUserName ? selectedRow?.assignedUserName : "Select a User"}
                                </MenuItem>
                                {users.map((user) => (
                                  <MenuItem key={user} value={user}>
                                    {user.name}
                                  </MenuItem>
                                ))}
                              </Select>
                            </DialogContent>
                            <DialogActions>
                              <Button onClick={closeAssignUserDialog}>
                                Cancel
                              </Button>
                              <Button
                                onClick={handleAssignment}
                                disabled={!selectedUser}
                              >
                                Save
                              </Button>
                            </DialogActions>
                          </Dialog>

                            <Button
                              style={{ whiteSpace: "nowrap" }}
                              variant="outlined"
                              disabled={row?.approvalStatus !== "Approved" || row?.orderStatus==="Cancelled" || row?.orderStatus==="Closed"}
                              onClick={() =>
                                  {
                                     retrieveOrderByIdApi(row?.id)
                                         .then((response) => {
                                           setShowShipmentRequestPopup({
                                             data: response?.data,
                                             visible: true,
                                           })
                                         })
                                         .catch((error) => {
                                           window.alert("Failed to retrieve order. Please try again later.");
                                         });
                                   }
                              }
                            >
                              Create Shipment Request
                            </Button>
                            {loadingRecord === row?.id ? (
                             <ClipLoader color="#000000" loadingRecord={loadingRecord} size={35} />
                              ) : (
                            <Button
                              style={{ whiteSpace: "nowrap" }}
                              variant="outlined"
                              color="warning"
                              disabled={row?.recordStatus==="PASSIVE" || row?.orderStatus==="Closed"}
                              onClick={() => {
                                if (
                                  window.confirm(
                                    `Are you sure you want to cancel SO ${
                                      row?.salesOrderNumber || ""
                                    } for item: ${
                                      row?.offerItemBuyingGrade
                                    }\nSO Quantity: ${row?.volume || "-"}  ${
                                      row?.volumeUnit || ""
                                    } `,
                                  )
                                ) {
                                  cancelOrder(row);
                                }
                              }}
                            >
                              Cancel SO
                            </Button>
                          )}
                            </div>
                            )}
                          </TableCell>

                          <TableCell align="center"  sx={{
                              position: "sticky",
                              left: showButtons ? 50 + 580 : 50,
                              background: "inherit",
                              zIndex: 1,
                            }}>{row?.id}</TableCell>
                          <TableCell align="center"  sx={{
                              position: "sticky",
                              left: showButtons ? 115 + 580 : 115,
                              background: "inherit",
                              zIndex: 1,
                            }}>
                            {row?.salesOrderNumber}
                          </TableCell>
                          <TableCell align="center">
                          {row?.orderYear}
                            {row?.orderYear && row?.orderGroupNumber && "-"}
                            {row?.orderGroupNumber}
                          </TableCell>
                          <TableCell align="center">
                            {row?.assignedUserName}
                          </TableCell>
                          <TableCell align="center">
                            {row?.orderStatus}
                          </TableCell>
                          <TableCell align="center">
                            {row?.company}
                          </TableCell>
                          <TableCell align="center">
                          <ItemButton
                              row={row}
                              setEditItem={setEditItem}
                            />
                          </TableCell>
                          <TableCell align="center"
                             sx={{
                              position: "sticky",
                              left: showButtons ? 274 + 580 : 274,
                              background: "inherit",
                              zIndex: 1,
                            }}>
                            {row?.offerItemTobaccoCode}
                          </TableCell>
                          <TableCell align="center"  sx={{
                              position: "sticky",
                              left: showButtons ? 417 + 580 : 417,
                              background: "inherit",
                              zIndex: 1,
                            }}>
                            {row?.offerItemBuyingGrade}
                          </TableCell>
                          <TableCell align="center">
                            {row?.offerSalesGrade}
                          </TableCell>
                          <TableCell align="center">
                            {row?.offerItemCrop}
                          </TableCell>
                          <TableCell align="center">
                            {row?.offerItemNicotine}
                          </TableCell>
                          <TableCell align="center">
                            {row?.offerItemSugar}
                          </TableCell>
                          <TableCell align="center">
                            {row?.offerItemMoisture}
                          </TableCell>
                          <TableCell align="center">
                            {row?.offerItemOrigin}
                          </TableCell>
                          <TableCell align="center">
                            {row?.offerItemStorage}
                          </TableCell>
                          <TableCell align="center">
                            {row?.offerItemType}
                          </TableCell>
                          <TableCell align="center">{row?.warehouse}</TableCell>
                          <TableCell align="center">
                            {row?.stakeholderCode}
                          </TableCell>
                          <TableCell align="center">
                            {row?.stakeholderName}
                          </TableCell>
                          <TableCell align="center">
                          <SampleButton
                              row={row}
                              id={row?.firstSampleId}
                              setEditSample={setEditSample}
                            />
                          </TableCell>
                          <TableCell align="center">
                            {row?.firstSampleDeliveryDate
                              ? format(
                                  new Date(row?.firstSampleDeliveryDate),
                                  "dd/MM/yyyy",
                                )
                              : ""}
                          </TableCell>
                          <TableCell align="center">
                            {row?.firstSampleStatus}
                          </TableCell>
                          <TableCell align="center">{row?.packaging}</TableCell>
                          <TableCell align="center">
                            {row?.netWeightPerCase}
                          </TableCell>
                          <TableCell align="center">
                            {row?.numberOfCases}
                          </TableCell>
                          <TableCell align="center">  {row?.volume
                              ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(row.volume)}`
                              : ""}{" "}
                            {row?.volumeUnit} </TableCell>
                            <TableCell align="center">
                            {row?.remainingQuantity ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(row.remainingQuantity)} ${row?.volumeUnit}`
                              : "0.00"}{" "}
                          </TableCell>
                          <TableCell align="center">
                            {row?.offerFirstOfferPrice
                              ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(row?.offerFirstOfferPrice)}`
                              : ""}{" "}
                            {row?.offerFirstOfferPriceCurrency}
                          </TableCell>
                          <TableCell align="center">
                          {row?.offerUsdFirstOfferPrice
                              ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(row?.offerUsdFirstOfferPrice)} USD`
                              : ""}{" "}
                          </TableCell>
                          <TableCell align="center">
                            {row?.finalPrice
                              ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(row?.finalPrice)}`
                              : ""}{" "}
                            {row?.finalPriceCurrency}
                          </TableCell>
                          <TableCell align="center">
                          {row?.usdFinalPrice
                              ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(row?.usdFinalPrice)} USD`
                              : ""}{" "}
                          </TableCell>
                          <TableCell align="center">
                            {row?.totalAmount
                              ? `${new Intl.NumberFormat("en-US", {
                                  style: "decimal",
                                  minimumFractionDigits: 2,
                                }).format(row.totalAmount)}`
                              : ""}{" "}
                            {row?.finalPriceCurrency}
                          </TableCell>
                           <TableCell align="center">
                             {row?.volume
                               ? row?.usdFinalPrice ? `${new Intl.NumberFormat("en-US", {
                                   style: "decimal",
                                   minimumFractionDigits: 2,
                                 }).format(row.volume*row.usdFinalPrice)}`
                               : "" : ""}{" "}
                             USD
                            </TableCell>
                          <TableCell align="center">
                            {row?.contractValueDate
                              ? format(
                                  new Date(row?.contractValueDate),
                                  "dd/MM/yyyy",
                                )
                              : ""}
                          </TableCell>
                          <TableCell align="center">{row?.incoterm}</TableCell>
                          <TableCell align="center">
                            {row?.portOfDischarge}
                          </TableCell>
                          <TableCell align="center">
                            {row?.portOfLoading}
                          </TableCell>
                          <TableCell align="center">
                            {row?.paymentTerm}
                          </TableCell>
                          <TableCell align="center">
                            {row?.operationDate
                              ? format(
                                  new Date(row?.operationDate),
                                  "dd/MM/yyyy",
                                )
                              : ""}
                          </TableCell>
                          <TableCell align="center">
                            {row?.estimatedTimeOfDeparture
                              ? format(
                                  new Date(row?.estimatedTimeOfDeparture),
                                  "dd/MM/yyyy",
                                )
                              : ""}
                          </TableCell>
                          <TableCell align="center">
                            {row?.estimatedTimeOfArrival
                              ? format(
                                  new Date(row?.estimatedTimeOfArrival),
                                  "dd/MM/yyyy",
                                )
                              : ""}
                          </TableCell>
                          <TableCell align="left">
                              {row?.descriptionOfGoods?.length > 50 ? (
                                <span style={{
                                  display: 'inline-block',
                                  maxWidth: '350px', 
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  verticalAlign: 'top',
                                }}
                                title={row?.descriptionOfGoods}>
                                  {row?.descriptionOfGoods}
                                </span>
                              ) : (
                                row?.descriptionOfGoods
                              )}
                            </TableCell>
                          <TableCell align="left">
                              {row?.shipmentSchedule?.length > 100 ? (
                                <span style={{
                                  display: 'inline-block',
                                  maxWidth: '350px', 
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  verticalAlign: 'top',
                                }}
                                title={row?.shipmentSchedule}>
                                  {row?.shipmentSchedule}
                                </span>
                              ) : (
                                row?.shipmentSchedule
                              )}
                            </TableCell>
                          <TableCell align="center">{row?.customerReference}</TableCell>
                          <TableCell align="center">{row?.remark}</TableCell>
                          <TableCell align="center">{row?.comment}</TableCell>
                          <TableCell align="center">
                          <OfferButton
                              row={row}
                              setEditOffer={setEditCustomerOffer}
                            />
                          </TableCell>
                          <TableCell align="center">
                            {row?.offerYear +
                              "-" +
                              row?.offerGroupNumber}
                          </TableCell>
                          <TableCell align="center">
                            {row?.offerDate
                              ? format(
                                  new Date(row?.offerDate),
                                  "dd/MM/yyyy",
                                )
                              : ""}
                          </TableCell>
                          <TableCell align="center">{row?.province}</TableCell>
                          <TableCell align="center">
                            {row?.shippingTerm}
                          </TableCell>
                          <TableCell align="center">
                            <a
                              href={row?.contractLink}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {row?.contractLink && (
                                <Button
                                  disableElevation
                                  variant="outlined"
                                  size="small"
                                >
                                  Contract Link
                                </Button>
                              )}
                            </a>
                          </TableCell>
                          <TableCell align="center">
                            {row?.approvalStatus}{row?.approvalStatus==="Declined" && (row?.declineNote ? ("-"  + row?.declineNote) : "")}
                          </TableCell>
                          <TableCell align="center">
                            {row?.timestamp
                              ? format(
                                  new Date(row.timestamp),
                                  "dd/MM/yyyy HH:mm",
                                )
                              : ""}
                          </TableCell>
                          <TableCell align="center">{row?.creator}</TableCell>
                          <TableCell align="center">
                            {row?.recordStatus}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                    {emptyRows > 0 && (
                      <TableRow
                        style={{
                          height: (dense ? 33 : 53) * emptyRows,
                        }}
                      >
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>*/}
                <div style={{ 
                                     position: "sticky", 
                                     top: 0, 
                                     background: "white", 
                                     padding: "10px", 
                                     fontWeight: "bold", 
                                     borderBottom: "1px solid #ddd", 
                                     zIndex: 10, 
                                     display: "flex", 
                                     gap: "20px"
                                   }}>
                                       <span>Total Quantity: {new Intl.NumberFormat("en-US", { 
                                       style: "decimal", 
                                       minimumFractionDigits: 2 
                                     }).format(totalVolume)} {rows.length > 0 ? rows[0]?.volumeUnit : ""}</span>
                            
                                     <span>Total Amount: {new Intl.NumberFormat("en-US", { 
                                       style: "decimal", 
                                       minimumFractionDigits: 2 
                                     }).format(usdTotalAmount)} {rows.length > 0 ? "USD" : ""}</span>
                                  </div>
              <div style={{ marginTop: '20px', marginLeft: '20px' }}>
  <div style={{ display: 'flex', flexDirection: 'row', gap: '20px', alignItems: 'center' }}>
  <div style={{ display: "flex", alignItems: "center" }}>
  <span
                      style={{
                        background: "#c8e6c9",
                        padding: "4px 8px",
                        marginRight: "5px",
                        borderRadius: "8px",
                        display: "inline-block",
                      }}
                    >
                      Created
                    </span>
                    <span>- SO file created</span>
                  </div>
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <span
        style={{
          background: "#FFCDD2",
          padding: "4px 8px",
          marginRight: "5px",
          borderRadius: '8px', 
          display: 'inline-block',
        }}
      >
        Closed
      </span>
      <span>- All Shipped</span>
    </div>
  </div>
</div>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50]}
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
            <FormControlLabel
              control={<Switch checked={dense} onChange={handleChangeDense} />}
              label="Dense padding"
            />
          </Box>
         <BlocksDialog
            open={blocksOpen}
            onClose={() => setBlocksOpen(false)}
            blocks={blockData}
          />
        </>
      )}
    </div>
  );
}
